var consumerDetails = (function () {

    //#region variables
    var SelectedIncidentId;
    var consumerNameP;
    var consumerPhoto;
    var consumerId;
    var itConsumersInvoled = [];
    var incidentLocations = [];
    var consumerInvolementId;
    var topDiv;
    var contentDiv;
    var formReadOnly = false;
    var SelectedConsumer;



    //behaviour
    var behaviorReviewTable;
    var selectedBehaviorId;
    var behaviorTypes;
    var behaviourForm;
    var behaviorTypeDropdown;
    var startTimeInput;
    var endTimeInput;
    var occurrencesInput;
    var behaviouirFormButtons;
    var behaviorData;
    var isEdit;
    var behaviorType;
    var behaviorTypeId;
    var startTime;
    var endTime;
    var occurrences;
    var behaviourSaveBtn;
    var behaviourCancelBtn;
    var addBehaviourBtn;
    var tmpBehaviorTypeId = null;
    var tmpStartTime = null;
    var tmpEndTime = null;
    var tmpOccurrences = null;
    var behaviorDeleteData;

    //followup
    var followupTable;
    var selectedFollowUpId;
    var dueDate;
    var dateCompleted;
    var followUpTypeId;
    var followUpTypes;
    var personResponsible;
    var followUpNote;
    var followUpTypeDropdown;
    var followupSaveBtn;
    var followupCancelBtn;
    var followUpsData;
    var addFollowupBtn;
    var followUpsDeleteData;

    //injury
    var selectedInjuryId;
    var injuriesTable;
    var injuryData;
    var injuryLocations;
    var injuryLocationId;
    var injuryTypeId;
    var injuryCauseId;
    var injuryRiskId;
    var checkedByNurse;
    var details;
    var treatment;
    var dateChecked;
    var injuryTypes;
    var injuryRisks;
    var injuryCauses;
    var injurySaveBtn;
    var injuryCancelBtn;
    var injuryLocationDropdown;
    var injuryTypeDropdown;
    var injuryCauseDropdown;
    var riskOfInjuryDropdown;
    var checkedByNurseCheckbox;
    var detailsInput;
    var treatmentInput;
    var dateCheckedInput;
    var injuryFormButtons;
    var addInjuryBtn;
    var injuryDeleteData;

    //intervention
    var interventionTable;
    var selectedInterventionId;
    var interventionTypes;
    var interventionSaveBtn;
    var interventionCancelBtn;
    var interventionTypeId;
    var interventionStartTime;
    var interventionEndTime;
    var interventionTimeLength;
    var aversive;
    var interventionNotes;
    var interventionTypeDropdown;
    var interventionStartTimeInput;
    var interventionEndTimeInput;
    var interventionTotalTimeLengthInput;
    var aversiveCheckbox;
    var interventionNotesInput;
    var interventionData;
    var interventionFormButtons;
    var adInterventionBtn;
    var interventionDeleteData;

    //reports
    var selectedReportId;
    var reportingCategoryDropdown;
    var reportedByInput;
    var reportedToInput;
    var reportMethodInput;
    var reportDateInput;
    var reportTimeInput;
    var reportNotesInput;
    var reportFormButtons;
    var reportSaveBtn;
    var reportCancelBtn;
    var reportTable;
    var reportingData;
    var reportingCategories;
    var dateReported;
    var reportTime;
    var reportBy;
    var reportMethod;
    var reportTo;
    var reportingCategoryId;
    var reportNotes;
    var addReportBtn;
    var reportingDeleteData;

    //review
    var selectedReviewId;
    var reviewTable;
    var newReviewBtn;
    var reviewDateInput;
    var reviewedByDropdown;
    var reviewednotesInput;
    var reviewedformButtons;
    var reviewedSaveBtn;
    var reviewedCancelBtn;
    var reviewData;
    var reviewDeleteData;
    var reviewedByDropdownData;
    var reviewedDate;
    var reviewedById;
    var reviewNotes;
    //#endregion
    var newIncident;

    //#region common
    function parseStartTime(dirtyStart) {
        const splittime = dirtyStart.split(' ');
        const time = `${splittime[1]} ${splittime[2]}`;
        return UTIL.convertToMilitary(time);
    }
    function formatTime(dirtyTime) {
        dirtyTime.replace('-', '');
        const splitTime = dirtyTime.split(':');
        const hours = splitTime[0].length === 1 ? `0${splitTime[0]}` : splitTime[0];
        const minutes = splitTime[1].length === 1 ? `0${splitTime[1]}` : splitTime[1];
        return `${hours}:${minutes}`;
    }
    function getTimeLength(start, end) {
        if (!start || !end) return '';
        if (start.includes('/')) {
            start = start.split(' ')[1];
        }
        let totalTime = UTIL.calculateTotalHours(start, end, 'hh:mm');
        totalTime = formatTime(totalTime);
        return totalTime;
    }
    function buildNavigation() {

        var navEle = document.createElement('div');
        var ulEle = document.createElement('ul');
        var liIncidentDetailsEle = document.createElement('li');
        liIncidentDetailsEle.style.marginBottom = '15px';
        var linkIncidentDetailsEle = document.createElement('a');
        linkIncidentDetailsEle.textContent = 'Incident Details';
        linkIncidentDetailsEle.style.fontWeight = 'bold';
        linkIncidentDetailsEle.style.cursor = 'pointer';
        linkIncidentDetailsEle.classList.add('incident_details_link');
        liIncidentDetailsEle.appendChild(linkIncidentDetailsEle);
        ulEle.appendChild(liIncidentDetailsEle);
        var liIndividualsInvolvedTextEle = document.createElement('li');
        var pIndividualsInvolvedTextEle = document.createElement('p');
        pIndividualsInvolvedTextEle.textContent = 'Individuals Involved';
        pIndividualsInvolvedTextEle.style.fontWeight = 'bold';
        pIndividualsInvolvedTextEle.style.marginBottom = '10px';
        liIndividualsInvolvedTextEle.appendChild(pIndividualsInvolvedTextEle);
        liIndividualsInvolvedTextEle.style.marginBottom = '15px';
        ulEle.appendChild(liIndividualsInvolvedTextEle);
        var ulIndividualsEleContainer = document.createElement('ul');
        ulIndividualsEleContainer.classList.add('individuals_involved_list');
        ulEle.appendChild(ulIndividualsEleContainer);
        navEle.appendChild(ulEle);
        return navEle;
    }
    function updateIndividualNavMenuItems() {
        var individualNavItems = [];
        // Get consumers involved in incident - ONLY if SelectedIncidentId exists       
        if (itConsumersInvoled && itConsumersInvoled.length > 0) {
            itConsumersInvoled = itConsumersInvoled.sort((a, b) =>
                a.lastName.localeCompare(b.lastName, undefined, { sensitivity: "base" }));
            itConsumersInvoled.forEach(consumer => {
                var liIndividualEle = document.createElement('li');
                var linkIndividualEle = document.createElement('a');
                linkIndividualEle.textContent = `${consumer.lastName}, ${consumer.firstName} ${consumer.middleName || ''}`;
                linkIndividualEle.style.cursor = 'pointer';
                linkIndividualEle.setAttribute('data-consumer-id', consumer.consumerId);
                linkIndividualEle.setAttribute('data-consumer-involvement-id', consumer.consumerInvolvedId);
                linkIndividualEle.classList.add('individual_nav');
                if (consumer.consumerId == consumerId) {
                    linkIndividualEle.classList.add('active');
                    handleIndividualNavEvents(linkIndividualEle)
                }
                liIndividualEle.style.padding = '8px';
                liIndividualEle.appendChild(linkIndividualEle);
                individualNavItems.push(liIndividualEle);
            });
        }
        var individualNavContainer = document.querySelector('.individuals_involved_list');
        individualNavContainer.innerHTML = '';
        individualNavItems.forEach(item => { individualNavContainer.appendChild(item) });

    }
    function handleIndividualNavEvents(target) {
        try {
            showProgressPopup('Please wait while we gather everything up...');
            if (!target.classList.contains('individual_nav')) return;
            consumerId = target.getAttribute('data-consumer-id');
            consumerInvolementId = target.getAttribute('data-consumer-involvement-id');
            getBehaviorData();
            getFollowupsdata();
            getInterventionData();
            getReportData();
            getReviewData();
            getInjuryData();
            consumerNameP.textContent = target.textContent;
            consumerPhoto.src = `./images/portraits/${consumerId}.png`;
            consumerPhoto.onerror = function () { consumerPhoto.src = './images/new-icons/default.jpg'; }
            document.querySelectorAll("a.individual_nav.active").forEach(a => a.classList.remove("active"));
            target.classList.add('active');
            topDiv.style.display = 'block';
            addBehaviourBtn.classList.remove('disabled');
            addFollowupBtn.classList.remove('disabled');
            addInjuryBtn.classList.remove('disabled');
            adInterventionBtn.classList.remove('disabled');
            addReportBtn.classList.remove('disabled');
            newReviewBtn.classList.remove('disabled');
            setTimeout(() => { hideProgressPopup(); }, 2000);
        }
        catch (error) {
            hideProgressPopup();
            console.log(error);
            failSave.show('An error occured');
            setTimeout(() => { failSave.hide(); }, 3000);
        }
    }
    function clearTable(tableId) {
        var tableObj = document.getElementById(tableId);
        if (tableObj) {
            var tableBody = tableObj.querySelector('.table__body');
            tableBody.innerHTML = '';
        }
    }
    //#endregion

    //#region behavioural
    function checkBehaviourRequiredFields() {
        var behaviourEntry = document.querySelector('div.behaviourContent');
        var hasErrors = [].slice.call(behaviourEntry.querySelectorAll('.error:not(button)'));
        if (hasErrors.length === 0) {
            behaviourSaveBtn.classList.remove('disabled');
        } else {
            behaviourSaveBtn.classList.add('disabled');
        }
    }
    function getConsumerBehaviorTypes() {
        incidentTrackingAjax.getitConsumerBehaviorTypes(function (res) {
            behaviorTypes = res;
        });
    }
    function getBehaviorData(deleteWarning) {
        clearTable('consumerBehaviorTable');
        incidentTrackingAjax.getitConsumerBehavior(consumerId, SelectedIncidentId, res => {
            behaviorData = [];
            if (res && res.length > 0) {
                res.forEach(d => {
                    if (!behaviorData[consumerId]) {
                        behaviorData[consumerId] = {};
                    }
                    if (!behaviorData[consumerId][d.itConsumerBehaviorId]) {
                        behaviorData[consumerId][d.itConsumerBehaviorId] = d;
                        behaviorData[consumerId][d.itConsumerBehaviorId].updated = false;
                    }
                });
            }
            populateBehaviourTable();
            if (deleteWarning) {
                let t = setTimeout(function () {
                    POPUP.hide(deleteWarning);
                    clearTimeout(t);
                }, 500);
               
            }
        });
    }
    function buildBehaviorTypeDropdown() {
        var opts = {
            label: 'Behavior Type',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var behaviortypeDrop = dropdown.build(opts);
        var data = behaviorTypes.map(fu => {
            return {
                value: fu.itBehaviorTypeId,
                text: fu.behaviorTypeName
            };
        });
        data.sort((a, b) => {
            return a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1;
        });
        data.unshift({
            value: '%',
            text: ''
        });
        dropdown.populate(behaviortypeDrop, data, behaviorTypeId);
        if (!behaviorTypeId || behaviorTypeId === '%') {
            behaviortypeDrop.classList.add('error');
        } else {
            behaviortypeDrop.classList.remove('error');
        }
        return behaviortypeDrop;
    }
    function buildStartTimeInput() {
        var opts = {
            label: 'Start Time',
            type: 'time',
            style: 'secondary',
            value: startTime
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var startTimeInput = input.build(opts);
        return startTimeInput;
    }
    function buildEndTimeInput() {
        var opts = {
            label: 'End Time',
            type: 'time',
            style: 'secondary',
            value: endTime          
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var endTimeInput = input.build(opts);
        return endTimeInput;
    }
    function buildOccurrencesInput() {
        var opts = {
            label: 'No. of Occurrences',
            type: 'number',
            style: 'secondary',
            value: occurrences,
            attributes: [{
                key: 'min',
                value: 1
            }, {
                key: 'step',
                value: 1
            }]
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var occurrencesInput = input.build(opts);
        return occurrencesInput;
    }
    function buildBehaviourFormBtns() {
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        behaviourSaveBtn = button.build({
            text: 'Save',
            type: 'contained',
            style: 'secondary',
            classNames: 'disabled',
            callback: function (e) {
                behaviourSaveBtn.classList.add('disabled');
                if (!behaviorData) {
                    behaviorData = [];
                }
                if (!behaviorData[consumerId]) {
                    behaviorData[consumerId] = {};
                }
                if (!behaviorData[consumerId][selectedBehaviorId]) {
                    var keys = Object.keys(behaviorData[consumerId]);
                    selectedBehaviorId = keys.length === 0 ? `new${keys.length}` : `new${keys.length + 1}`;
                    behaviorData[consumerId][selectedBehaviorId] = {
                        behaviorTypeId: '',
                        startTime: '',
                        endTime: '',
                        occurrences: '',
                        updated: ''
                    };
                }
                if (tmpBehaviorTypeId !== null || tmpStartTime !== null || tmpEndTime !== null || tmpOccurrences !== null) {
                    behaviorData[consumerId][selectedBehaviorId].updated = true;
                }
                if (tmpBehaviorTypeId !== null) {
                    behaviorData[consumerId][selectedBehaviorId].behaviorTypeId = tmpBehaviorTypeId;
                }
                if (tmpStartTime !== null) {
                    behaviorData[consumerId][selectedBehaviorId].startTime = tmpStartTime;
                }
                if (tmpEndTime !== null) {
                    behaviorData[consumerId][selectedBehaviorId].endTime = tmpEndTime;
                }
                if (tmpOccurrences !== null) {
                    behaviorData[consumerId][selectedBehaviorId].occurrences = tmpOccurrences;
                }
                saveConsumerBehaviors().then(() => {
                    clearBehaviourForm();
                    var behaviourEntry = document.querySelector('div.behaviourContent');
                    behaviourEntry.innerHTML = '';
                    addBehaviourBtn.classList.remove('hidden');
                    getBehaviorData();
                    behaviourSaveBtn.classList.remove('disabled');
                    successfulSave.show();
                    setTimeout(function () { successfulSave.hide(); }, 2000);
                });
            }
        });
        behaviourCancelBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary',
            callback: function (e) {
                clearBehaviourForm();
                var behaviourEntry = document.querySelector('div.behaviourContent');
                behaviourEntry.innerHTML = '';
                addBehaviourBtn.classList.remove('hidden');
            }
        });
        if (!formReadOnly) btnWrap.appendChild(behaviourSaveBtn);
        btnWrap.appendChild(behaviourCancelBtn);
        return btnWrap;
    }
    function clearBehaviourForm() {
        selectedBehaviorId = undefined;
        behaviorType = undefined;
        behaviorTypeId = undefined;
        startTime = undefined;
        endTime = undefined;
        occurrences = undefined;
        tmpBehaviorTypeId = null;
        tmpEndTime = null;
        tmpStartTime = null;
        tmpOccurrences = null;
    }
    function setBehaviourFormDataDefaults(formData) {
        if (formData) {
            behaviorType = formData.behaviorType;
            behaviorTypeId = formData.behaviorTypeId;
            startTime = formData.startTime;
            endTime = formData.endTime;
            occurrences = formData.occurrences;
        }
    }
    function validateBehaviorStartAndEndTime(tmpStartTime, tmpEndTime) {
        if (tmpStartTime) {
            if (!tmpEndTime) { endTimeInput.classList.add('error'); }
            else if (tmpEndTime) { endTimeInput.classList.remove('error'); }
        }
        if (tmpEndTime) {
            if (!tmpStartTime) { startTimeInput.classList.add('error'); }
            else if (tmpStartTime) { startTimeInput.classList.remove('error'); }          
        }
        if (tmpStartTime && tmpEndTime) {
            if (tmpEndTime < tmpStartTime) {
                startTimeInput.classList.add('error');
                endTimeInput.classList.add('error');
            }
            else {
                startTimeInput.classList.remove('error');
                endTimeInput.classList.remove('error');
            }
        }
        checkBehaviourRequiredFields();
    }
    function setupBehaviourEvents() {

        behaviorTypeDropdown.addEventListener('change', e => {
            if (!e.target.value || e.target.value === '%') {
                behaviorTypeDropdown.classList.add('error');
            } else {
                behaviorTypeDropdown.classList.remove('error');
            }
            tmpBehaviorTypeId = e.target.value;
            checkBehaviourRequiredFields();
        });
        startTimeInput.addEventListener('change', e => {
            tmpStartTime = e.target.value;
            validateBehaviorStartAndEndTime(tmpStartTime, tmpEndTime);
        });
        endTimeInput.addEventListener('change', e => {
            tmpEndTime = e.target.value;
            validateBehaviorStartAndEndTime(tmpStartTime, tmpEndTime);
        });
        occurrencesInput.addEventListener('keyup', e => {
            if (e.target.value < 0 || e.target.value.includes('-')) {
                occurrencesInput.classList.add('error');
            } else {
                occurrencesInput.classList.remove('error');
            }
            checkBehaviourRequiredFields();
        });
        occurrencesInput.addEventListener('change', e => {
            tmpOccurrences = e.target.value;
        });

    }
    function buildNewBehaviorForm() {
        behaviourForm = document.createElement('div');
        behaviourForm.classList.add('behaviorForm');
        behaviorTypeDropdown = buildBehaviorTypeDropdown();
        startTimeInput = buildStartTimeInput();
        endTimeInput = buildEndTimeInput();
        occurrencesInput = buildOccurrencesInput();
        behaviouirFormButtons = buildBehaviourFormBtns();
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '10px';
        container.style.marginBottom = '10px';
        container.style.width = '100%';
        container.appendChild(behaviorTypeDropdown);
        container.appendChild(occurrencesInput);
        container.appendChild(startTimeInput);
        container.appendChild(endTimeInput);
        behaviourForm.appendChild(container);        
        behaviourForm.appendChild(behaviouirFormButtons);       
        return behaviourForm;
    }
    function showBehaviourForm(isedit) {
        isEdit = isedit;
        addBehaviourBtn.classList.add('hidden');
        var behaviourEntry = document.querySelector('div.behaviourContent');
        if (behaviourEntry) {
            behaviourEntry.innerHTML = '';
            behaviourEntry.appendChild(buildNewBehaviorForm());
            setupBehaviourEvents();
        }
    }
    function showBehaviourDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this record?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                if (!selectedBehaviorId.includes('new')) {
                    behaviorDeleteData = [];
                    var deletedBehavior = behaviorData[consumerId][selectedBehaviorId];
                    if (!behaviorDeleteData[consumerId]) behaviorDeleteData[consumerId] = {};
                    behaviorDeleteData[consumerId][selectedBehaviorId] = deletedBehavior;
                    if (behaviorDeleteData && behaviorDeleteData.length > 0) {
                        var bhKeys = Object.keys(behaviorDeleteData);
                        bhKeys.forEach(fuKey => {
                            var keys = Object.keys(behaviorDeleteData[fuKey]);
                            keys.forEach(key => {
                                incidentTrackingAjax.itDeleteConsumerBehavior(key, () => {
                                    getBehaviorData(deleteWarningPopup);
                                    if (isEdit) {
                                        clearSections('behavior');
                                    }
                                });
                            });
                        });
                    }
                    else {
                        POPUP.hide(deleteWarningPopup);
                    }
                    selectedBehaviorId = undefined;                                   
                }
                else {
                    delete behaviorData[consumerId][selectedBehaviorId];
                    selectedBehaviorId = undefined;
                    populateBehaviourTable();
                    POPUP.hide(deleteWarningPopup);
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function buildBehaviourContent() {
        behaviorReviewTable = table.build({
            tableId: 'consumerBehaviorTable',
            columnHeadings: ['Behavior Type', 'Time Length', 'Occurrences'],
            endIcon: true,
        });
        behaviorReviewTable.addEventListener('click', event => {
            if (event.target.classList.contains('table__row') && !event.target.classList.contains('header')) {
                selectedBehaviorId = event.target.id;
                setBehaviourFormDataDefaults(behaviorData[consumerId][selectedBehaviorId]);
                showBehaviourForm(true);
                checkBehaviourRequiredFields();

            }
            else if (event.target.classList.contains('endIcon')) {
                var row = event.target.closest('.table__row');
                selectedBehaviorId = row.id;
                showBehaviourDeleteWarning();
            }
        });
        var divBehaviourContent = document.createElement('div');
        var headingBehaviour = document.createElement('h4');
        headingBehaviour.style.marginBottom = '10px';
        headingBehaviour.textContent = 'Behavior Details';
        divBehaviourContent.appendChild(headingBehaviour);
        divBehaviourContent.appendChild(behaviorReviewTable);
        divBehaviourContent.style.paddingBottom = '50px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');        
        addBehaviourBtn = button.build({
            text: 'add behavior details',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: function (e) {
                showBehaviourForm(false);
            },
        });
        if (!formReadOnly) {
            btnWrap.appendChild(addBehaviourBtn);
        }
        divBehaviourContent.appendChild(btnWrap)
        var behaviourEntry = document.createElement('div');
        behaviourEntry.classList.add('behaviourContent');
        divBehaviourContent.appendChild(behaviourEntry);
        return divBehaviourContent;
    }
    function populateBehaviourTable() {
        if (!behaviorData) {
            behaviorData = [];
        }
        if (behaviorData.length == 0 || !behaviorData[consumerId]) return;
        let tableData = [];
        let keys = Object.keys(behaviorData[consumerId]);
        keys.forEach(key => {
            let behaviorDATA = behaviorData[consumerId][key];
            let filterBehaviorTypes = behaviorTypes.filter(type => type.itBehaviorTypeId === behaviorDATA.behaviorTypeId);
            let behaviorType = filterBehaviorTypes[0] ? filterBehaviorTypes[0].behaviorTypeName : '';
            let timeLength = getTimeLength(behaviorDATA.startTime, behaviorDATA.endTime);
            let occurrencesNum = behaviorDATA.occurrences;
            tableData.push({
                id: key,
                values: [behaviorType, timeLength, occurrencesNum],
                endIcon: $.session.incidentTrackingDelete ? `${icons['delete']}` : ''
            });
        });
        table.populate(behaviorReviewTable, tableData);

    }
    function saveConsumerBehaviors() {
        var saveData = {
            token: $.session.Token,
            consumerInvolvedId: consumerInvolementId,
            consumerBehaviorIdArray: [],
            behaviorTypeIdArray: [],
            startTimeArray: [],
            endTimeArray: [],
            occurrencesArray: []
        };
        var idKeys = Object.keys(behaviorData[consumerId]);
        idKeys.forEach(idKey => {
            var rData = behaviorData[consumerId][idKey];
            if (!rData.updated) return;
            var isNew = idKey.includes('new');
            var itConsumerBehaviorId = isNew ? '' : idKey;
            var behaviorTypeId = rData.behaviorTypeId ? rData.behaviorTypeId : '';
            var startTime = rData.startTime ? rData.startTime : '';
            var endTime = rData.endTime ? rData.endTime : '';
            var occurrences = rData.occurrences ? rData.occurrences : '';
            saveData.consumerBehaviorIdArray.push(itConsumerBehaviorId);
            saveData.behaviorTypeIdArray.push(behaviorTypeId);
            saveData.startTimeArray.push(startTime);
            saveData.endTimeArray.push(endTime);
            saveData.occurrencesArray.push(occurrences);
        });
        var savePromise = new Promise((fulfill, reject) => {
            incidentTrackingAjax.saveUpdateITConsumerBehaviors(saveData, () => {
                fulfill();
            });
        });
        return savePromise;
    }
    //#endregion

    //#region followup form
    function getFollowuptypes() {
        incidentTrackingAjax.getitConsumerFollowUpTypes(function (res) {
            followUpTypes = res;
        });
    }
    function getFollowupsdata(deleteWarning) {
        clearTable('consumerFollowUpTable');
        incidentTrackingAjax.getitConsumerFollowUps(consumerId, SelectedIncidentId, res => {
            followUpsData = [];
            if (res && res.length > 0) {
                res.forEach(d => {
                    if (!followUpsData[consumerId]) {
                        followUpsData[consumerId] = {};
                    }
                    if (!followUpsData[consumerId][d.itConsumerFollowUpId]) {
                        followUpsData[consumerId][d.itConsumerFollowUpId] = d;
                        followUpsData[consumerId][d.itConsumerFollowUpId].updated = false;

                        // format dates
                        var dateTimeCompleted = followUpsData[consumerId][d.itConsumerFollowUpId].dateCompleted;
                        var dueDateTime = followUpsData[consumerId][d.itConsumerFollowUpId].dueDate;
                        dateCompleted = dateTimeCompleted ? dateTimeCompleted.split(' ')[0] : null;
                        dueDate = dueDateTime ? dueDateTime.split(' ')[0] : null;
                        if (dateCompleted) {
                            followUpsData[consumerId][d.itConsumerFollowUpId].dateCompleted = UTIL.formatDateToIso(dateCompleted);
                        }
                        if (dueDate) {
                            followUpsData[consumerId][d.itConsumerFollowUpId].dueDate = UTIL.formatDateToIso(dueDate);
                        }
                    }
                });
            }
            populateFollowUpTable();
            if (deleteWarning) {
                let t = setTimeout(function () {
                    POPUP.hide(deleteWarning);
                    clearTimeout(t);
                }, 500);

            }
        })
    }
    function checkFollowupRequiredFields() {
        var hasErrors = false;
        var followUpTypeSelect = followUpTypeDropdown.querySelector('.dropdown__select');
        if (!followUpTypeSelect.value || followUpTypeSelect.value === '%') {
            followUpTypeDropdown.classList.add('error');
            hasErrors = true;
        } else {
            followUpTypeDropdown.classList.remove('error');
        }
        if (hasErrors) {
            followupSaveBtn.classList.add('disabled');
        } else {
            followupSaveBtn.classList.remove('disabled');
        }
    }
    function clearFollowupFormDataDefaults() {
        dueDate = undefined;
        dateCompleted = undefined;
        followUpTypeId = undefined;
        lastUpdatedBy = undefined;
        lastUpdatedOn = undefined;
        personResponsible = undefined;
        followUpNote = undefined;
    }
    function setFollowupFormDataDefaults(formData) {
        if (formData) {
            dueDate = formData.dueDate;
            dateCompleted = formData.dateCompleted;
            followUpTypeId = formData.followUpTypeId;
            personResponsible = formData.personResponsible;
            followUpNote = formData.notes;
        }
    }
    function setupFollowupFormEvents() {
        var tmpFollowUpTypeId;
        var tmpPersonResponsible;
        var tmpDueDate;
        var tmpCompletedDate;
        var tmpNote;
        followUpTypeDropdown.addEventListener('change', e => {
            tmpFollowUpTypeId = e.target.value;
            checkFollowupRequiredFields();
        });
        personResponsibleInput.addEventListener('change', e => {
            tmpPersonResponsible = e.target.value;
        });
        dueDateInput.addEventListener('change', e => {
            tmpDueDate = e.target.value;
        });
        completedDateInput.addEventListener('change', e => {
            tmpCompletedDate = e.target.value;
        });
        notesInput.addEventListener('change', e => {
            tmpNote = e.target.value;
        });

        formButtons.addEventListener('click', e => {
            if (e.target === followupSaveBtn) {
                followupSaveBtn.classList.add('disabled');
                if (!followUpsData) {
                    followUpsData = [];
                }
                if (!followUpsData[consumerId]) {
                    followUpsData[consumerId] = {};
                }
                if (!followUpsData[consumerId][selectedFollowUpId]) {
                    var keys = Object.keys(followUpsData[consumerId]);
                    selectedFollowUpId = keys.length === 0 ? `new${keys.length}` : `new${keys.length + 1}`;
                    followUpsData[consumerId][selectedFollowUpId] = {
                        dateCompleted: '',
                        dueDate: '',
                        followUpTypeId: '',
                        notes: '',
                        personResponsible: '',
                        updated: ''
                    };
                }
                if (tmpCompletedDate || tmpDueDate || tmpFollowUpTypeId || tmpNote || tmpPersonResponsible) {
                    followUpsData[consumerId][selectedFollowUpId].updated = true;
                }
                if (tmpCompletedDate) followUpsData[consumerId][selectedFollowUpId].dateCompleted = tmpCompletedDate;
                if (tmpDueDate) followUpsData[consumerId][selectedFollowUpId].dueDate = tmpDueDate;
                if (tmpFollowUpTypeId) followUpsData[consumerId][selectedFollowUpId].followUpTypeId = tmpFollowUpTypeId;
                if (tmpNote) followUpsData[consumerId][selectedFollowUpId].notes = tmpNote;
                if (tmpPersonResponsible) followUpsData[consumerId][selectedFollowUpId].personResponsible = tmpPersonResponsible;
                saveConsumerFollowUps().then(() => {
                    selectedFollowUpId = undefined;
                    clearFollowupFormDataDefaults();
                    var section = document.querySelector('div.section');
                    section.innerHTML = '';
                    addFollowupBtn.classList.remove('hidden');
                    getFollowupsdata();
                    successfulSave.show();
                    followupSaveBtn.classList.remove('disabled');
                    setTimeout(function () { successfulSave.hide(); }, 2000);
                    return;
                });
            }
            if (e.target === followupCancelBtn) {
                selectedFollowUpId = undefined;
                clearFollowupFormDataDefaults();
                var section = document.querySelector('div.section');
                section.innerHTML = '';
                addFollowupBtn.classList.remove('hidden');
                return;
            }
        });
    }
    function buildFollowUpTypeDropdown() {
        var opts = {
            label: 'Follow Up Type',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var followUptypeDrop = dropdown.build(opts);
        var data = followUpTypes.map(fu => {
            return {
                value: fu.itFollowUpTypeId,
                text: fu.followUpTypeName
            };
        });
        data.unshift({
            value: '%',
            text: ''
        });
        dropdown.populate(followUptypeDrop, data, followUpTypeId);
        return followUptypeDrop;
    }
    function buildPersonResponsibleInput() {
        var opts = {
            label: 'Person Responsible',
            type: 'text',
            style: 'secondary',
            value: personResponsible
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var personInput = input.build(opts);
        return personInput;
    }
    function buildDueDateInput() {
        var inputOptions = {
            label: 'Due Date',
            type: 'date',
            style: 'secondary',
            value: ''
        };
        if (dueDate) inputOptions.value = dueDate;
        if (isEdit && formReadOnly) {
            inputOptions.readonly = true;
        }
        var dateInput = input.build(inputOptions);
        dateInput.style.marginTop = '-20px';
        return dateInput;
    }
    function buildCompletedDateInput() {
        var inputOptions = {
            label: 'Date Completed',
            type: 'date',
            style: 'secondary',
            value: ''
        };
        if (dateCompleted) inputOptions.value = dateCompleted;
        if (isEdit && formReadOnly) {
            inputOptions.readonly = true;
        }
        var dateInput = input.build(inputOptions);
        dateInput.style.marginTop = '-20px';
        return dateInput;
    }
    function buildNotesInput() {
        var opts = {
            label: 'Note',
            type: 'textarea',
            style: 'secondary',
            value: followUpNote            
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var noteInput = input.build(opts);
        noteInput.classList.add('minheight');       
        return noteInput;
    }
    function buildFollowupFormBtns() {
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        followupSaveBtn = button.build({
            text: 'Save',
            type: 'contained',
            style: 'secondary',
            classNames: 'disabled'
        });
        followupCancelBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary'
        });
        if (!formReadOnly) btnWrap.appendChild(followupSaveBtn);
        btnWrap.appendChild(followupCancelBtn);
        return btnWrap;
    }
    function buildNewFollowUpForm() {
        var form = document.createElement('div');
        form.classList.add('followUpForm');
        followUpTypeDropdown = buildFollowUpTypeDropdown();
        personResponsibleInput = buildPersonResponsibleInput();
        dueDateInput = buildDueDateInput();
        completedDateInput = buildCompletedDateInput();
        notesInput = buildNotesInput();
        formButtons = buildFollowupFormBtns();
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '5px';
        container.style.width = '100%';
        container.appendChild(followUpTypeDropdown);
        container.appendChild(personResponsibleInput);
        container.appendChild(dueDateInput);
        container.appendChild(completedDateInput);
        form.appendChild(container);       
        form.appendChild(notesInput);
        form.appendChild(formButtons);
        return form;
    }
    function showFolllowupForm(isedit) {
        isEdit = isedit;
        addFollowupBtn.classList.add('hidden');
        var section = document.querySelector('div.section');
        section.innerHTML = '';
        var followUpForm = buildNewFollowUpForm();
        section.appendChild(followUpForm);
        setupFollowupFormEvents();
        checkFollowupRequiredFields();
    }
    function showFollowupDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this record?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                if (!selectedFollowUpId.includes('new')) {
                    followUpsDeleteData = [];
                    var deletedFollowUp = followUpsData[consumerId][selectedFollowUpId];
                    if (!followUpsDeleteData[consumerId]) followUpsDeleteData[consumerId] = {};
                    followUpsDeleteData[consumerId][selectedFollowUpId] = deletedFollowUp;
                    if (followUpsDeleteData && followUpsDeleteData.length > 0) {
                        var fuKeys = Object.keys(followUpsDeleteData);
                        fuKeys.forEach(fuKey => {
                            var keys = Object.keys(followUpsDeleteData[fuKey]);
                            keys.forEach(key => {
                                incidentTrackingAjax.itDeleteConsumerFollowUp(key, () => {
                                    getFollowupsdata(deleteWarningPopup);
                                    if (isEdit) {
                                        clearSections('followup');
                                    }
                                });
                            });
                        });
                    }
                    else {
                        POPUP.hide(deleteWarningPopup);
                    }
                    selectedFollowUpId = undefined;                    
                }
                else {
                    delete followUpsData[consumerId][selectedFollowUpId];
                    selectedFollowUpId = undefined;
                    populateFollowUpTable();
                    POPUP.hide(deleteWarningPopup);
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function buildFollowupContent() {
        followupTable = table.build({
            tableId: 'consumerFollowUpTable',
            columnHeadings: ['Follow Up Type', 'Person Responsible', 'Due Date'],
            endIcon: true
        });
        followupTable.addEventListener('click', event => {
            if (event.target.classList.contains('table__row') && !event.target.classList.contains('header')) {
                selectedFollowUpId = event.target.id;
                setFollowupFormDataDefaults(followUpsData[consumerId][selectedFollowUpId]);
                showFolllowupForm(true);
            }
            else if (event.target.classList.contains('endIcon')) {
                var row = event.target.closest('.table__row');
                selectedFollowUpId = row.id;
                showFollowupDeleteWarning();
            }
        });
        var divContent = document.createElement('div');
        var heading = document.createElement('h4');
        heading.style.marginBottom = '10px';
        heading.textContent = 'Follow Up';
        divContent.appendChild(heading);
        divContent.appendChild(followupTable);
        divContent.style.paddingBottom = '50px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');       
        addFollowupBtn = button.build({
            text: 'add follow up',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: function (e) {
                showFolllowupForm(false);
            },
        });
        if (!formReadOnly) {
            btnWrap.appendChild(addFollowupBtn);
        }
        divContent.appendChild(btnWrap);
        var section = document.createElement('div');
        section.classList.add('section');
        section.style.paddingTop = '5px';
        divContent.appendChild(section);
        return divContent;
    }
    function populateFollowUpTable() {
        if (!followUpsData) {
            followUpsData = [];
        }
        if (followUpsData.length == 0 || !followUpsData[consumerId]) return;
        var tableData = [];
        var keys = Object.keys(followUpsData[consumerId]);
        keys.forEach(key => {
            var followUpData = followUpsData[consumerId][key];
            var filterFollowUpTypes = followUpTypes.filter(type => type.itFollowUpTypeId === followUpData.followUpTypeId);
            var followUpType = filterFollowUpTypes[0] ? filterFollowUpTypes[0].followUpTypeName : '';
            var personResponsible = followUpData.personResponsible;
            var dueDate = followUpData.dueDate ? followUpData.dueDate.split(' ')[0] : '';
            dueDate = dueDate ? UTIL.formatDateFromIso(dueDate) : dueDate;
            tableData.push({
                id: key,
                values: [followUpType, personResponsible, dueDate],
                endIcon: $.session.incidentTrackingDelete ? `${icons['delete']}` : ''
            });
        });
        table.populate(followupTable, tableData);

    }
    function saveConsumerFollowUps() {
        var saveData = {
            token: $.session.Token,
            consumerInvolvedId: consumerInvolementId,
            consumerFollowUpIdArray: [],
            followUpTypeIdArray: [],
            personResponsibleArray: [],
            dueDateArray: [],
            completedDateArray: [],
            notesArray: []
        };

        var idKeys = Object.keys(followUpsData[consumerId]);
        idKeys.forEach(idKey => {
            var fuData = followUpsData[consumerId][idKey];
            if (!fuData.updated) return;
            var isNew = idKey.includes('new');
            var itConsumerFollowUpId = isNew ? '' : idKey;
            var followUpTypeId = fuData.followUpTypeId ? fuData.followUpTypeId : '';
            var personResponsible = fuData.personResponsible ? UTIL.removeUnsavableNoteText(fuData.personResponsible) : '';
            var dueDate = fuData.dueDate ? fuData.dueDate : '';
            var dateCompleted = fuData.dateCompleted ? fuData.dateCompleted : '';
            var notes = fuData.notes ? UTIL.removeUnsavableNoteText(fuData.notes) : '';
            saveData.consumerFollowUpIdArray.push(itConsumerFollowUpId);
            saveData.followUpTypeIdArray.push(followUpTypeId);
            saveData.personResponsibleArray.push(personResponsible);
            saveData.dueDateArray.push(dueDate);
            saveData.completedDateArray.push(dateCompleted);
            saveData.notesArray.push(notes);
        });
        var savePromise = new Promise((fulfill, reject) => {
            incidentTrackingAjax.saveUpdateITConsumerFollowUp(saveData, () => {
                fulfill();
            });
        });

        return savePromise;
    }
    //#endregion

    //#region injury
    function getInjuryData(deleteWarning) {
        clearTable('consumerInjuriesTable');
        incidentTrackingAjax.getitConsumerInjuries(consumerId, SelectedIncidentId, res => {
            injuryData = [];
            if (res && res.length > 0) {
                res.forEach(d => {
                    if (!injuryData[consumerId]) {
                        injuryData[consumerId] = {};
                    }
                    if (!injuryData[consumerId][d.itConsumerInjuryId]) {
                        injuryData[consumerId][d.itConsumerInjuryId] = d;
                        injuryData[consumerId][d.itConsumerInjuryId].updated = false;

                        // format dates
                        var dateChecked = injuryData[consumerId][d.itConsumerInjuryId].checkedDate;
                        dateChecked = dateChecked ? dateChecked.split(' ')[0] : null;
                        if (dateChecked) {
                            injuryData[consumerId][d.itConsumerInjuryId].checkedDate = UTIL.formatDateToIso(dateChecked);
                        }
                    }
                });
            }
            populateInjuryTable();
            if (deleteWarning) {
                let t = setTimeout(function () {
                    POPUP.hide(deleteWarning);
                    clearTimeout(t);
                }, 500);

            }
        });
    }
    async function getinjuryDropdownData() {
        const injuryDropDownPromise = new Promise((resolve, reject) => {
            incidentTrackingAjax.getInjuryLocationsDropdown(function (locations) {
                injuryLocations = locations;

                incidentTrackingAjax.getInjuryTypesDropdown(function (types) {
                    injuryTypes = types;

                    incidentTrackingAjax.getRiskAndCauseDropdown(function (riskAndCause) {
                        injuryRisks = riskAndCause.injuryRiskDropdown;
                        injuryCauses = riskAndCause.injuryCauseDropdowns;

                        resolve({
                            injuryLocations,
                            injuryTypes,
                            injuryRisks,
                            injuryCauses
                        });
                    });
                });
            });
        });

        const result = await injuryDropDownPromise;
        return result;
    }
    function checkInjuryRequiredFields() {
        var hasErrors = false;
        var injuryLocationSelect = injuryLocationDropdown.querySelector('.dropdown__select');
        var injuryTypeSelect = injuryTypeDropdown.querySelector('.dropdown__select');
        if (!injuryLocationSelect.value || injuryLocationSelect.value === '%') {
            injuryLocationDropdown.classList.add('error');
            hasErrors = true;
        } else {
            injuryLocationDropdown.classList.remove('error');
        }
        if (!injuryTypeSelect.value || injuryTypeSelect.value === '%') {
            injuryTypeDropdown.classList.add('error');
            hasErrors = true;
        } else {
            injuryTypeDropdown.classList.remove('error');
        }
        if (hasErrors) {
            injurySaveBtn.classList.add('disabled');
        } else {
            injurySaveBtn.classList.remove('disabled');
        }
    }
    function clearInjuryFormDataDefaults() {
        injuryLocationId = undefined;
        injuryTypeId = undefined;
        injuryCauseId = undefined;
        injuryRiskId = undefined;
        checkedByNurse = undefined;
        details = undefined;
        treatment = undefined;
        dateChecked = undefined;
        lastUpdatedBy = undefined;
        lastUpdatedOn = undefined;
    }
    function setInjuryFormDataDefaults(formData) {
        if (formData) {
            injuryLocationId = formData.injuryLocationId;
            injuryTypeId = formData.injuryTypeId;
            injuryCauseId = formData.injuryCauseId;
            injuryRiskId = formData.injuryRiskId;
            checkedByNurse = formData.checkedByNurse;
            details = formData.injuryDetails;
            treatment = formData.injuryTreatment;
            dateChecked = formData.checkedDate;
        }
    }
    function setupInjuryFormEvents() {
        let tmpInjuryLocation;
        let tmpInjuryType;
        let tmpInjuryCause;
        let tmpInjuryRisk;
        let tmpCheckedBy;
        let tmpDetails;
        let tmpTreatment;
        let tmpDateChecked;
        injuryLocationDropdown.addEventListener('change', e => {
            tmpInjuryLocation = e.target.value;
            checkInjuryRequiredFields();
        });
        injuryTypeDropdown.addEventListener('change', e => {
            tmpInjuryType = e.target.value;
            checkInjuryRequiredFields();
        });
        injuryCauseDropdown.addEventListener('change', e => {
            tmpInjuryCause = e.target.value;
        });
        riskOfInjuryDropdown.addEventListener('change', e => {
            tmpInjuryRisk = e.target.value;
        });
        checkedByNurseCheckbox.addEventListener('change', e => {
            tmpCheckedBy = e.target.checked ? 'Y' : 'N';
        });
        detailsInput.addEventListener('change', e => {
            tmpDetails = e.target.value;
        });
        treatmentInput.addEventListener('change', e => {
            tmpTreatment = e.target.value;
        });
        dateCheckedInput.addEventListener('change', e => {
            tmpDateChecked = e.target.value;
        });

        injuryFormButtons.addEventListener('click', e => {
            if (e.target === injurySaveBtn) {
                injurySaveBtn.classList.add('disabled');
                var saveData = {
                    token: $.session.Token,
                    checkedByNurseArray: tmpCheckedBy || checkedByNurse,
                    checkedDateArray: tmpDateChecked || dateChecked,
                    detailsArray: UTIL.removeUnsavableNoteText(tmpDetails || details),
                    itConsumerInjuryIdArray: selectedInjuryId,
                    consumerInvolvedId: consumerInvolementId,                  
                    itInjuryLocationIdArray: tmpInjuryLocation || injuryLocationId,
                    itInjuryTypeIdArray: tmpInjuryType || injuryTypeId,
                    treatmentArray: UTIL.removeUnsavableNoteText(tmpTreatment),
                    causeOfInjuryIdArray: tmpInjuryCause || injuryCauseId,
                    riskOfInjuryIdArray: tmpInjuryRisk || injuryRiskId
                };
               
                saveConsumerInjuries(saveData).then((result) => {
                    const res = JSON.parse(result);                  
                    if (res[0].msg === 'success') {
                        selectedInjuryId = undefined;
                        getInjuryData();
                        clearInjuryFormDataDefaults();
                        var section = document.querySelector('div.injury_section');
                        section.innerHTML = '';
                        addInjuryBtn.classList.remove('hidden');
                        successfulSave.show();
                        injurySaveBtn.classList.remove('disabled');
                        setTimeout(function () { successfulSave.hide(); }, 2000);
                        return;
                    }
                    else if (res[0].msg === 'duplicate') {
                        var filteredLocations = injuryLocations.filter(iLoc => iLoc.injuryLocationId === saveData.itInjuryLocationIdArray);
                        var filteredTypes = injuryTypes.filter(iType => iType.injuryTypeId === saveData.itInjuryTypeIdArray);
                        var injuryLocation = filteredLocations[0].injuryLocation;
                        var injuryType = filteredTypes[0].injuryType;
                        showInjuryExistWarning(injuryLocation, injuryType);
                    }                
                   
                });
            }
            if (e.target === injuryCancelBtn) {
                selectedInjuryId = undefined;
                clearInjuryFormDataDefaults();
                var section = document.querySelector('div.injury_section');
                section.innerHTML = '';
                addInjuryBtn.classList.remove('hidden');
                return;
            }
        });
    }
    function showInjuryExistWarning(injuryLocation,injuryTypeDesc) {
        const existWarningPopup = POPUP.build({
            classNames: 'warning',
            hideX: false,
        });
        const title = document.createElement('h3');
        title.textContent = 'Location And Injury Type Already Exists';
        existWarningPopup.appendChild(title);
        const message = document.createElement('p');
        message.innerHTML = `You are trying to insert a duplicate record (${injuryLocation} AND ${injuryTypeDesc}) into the database.  Record not saved.`;
        existWarningPopup.appendChild(message);
        const buttonContainer = document.createElement('div');
        buttonContainer.style.display = 'flex';
        buttonContainer.style.gap = '10px';
        buttonContainer.style.marginTop = '20px';
        buttonContainer.style.justifyContent = 'center';
        const OKBtn = button.build({
            text: 'OK',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                POPUP.hide(existWarningPopup);              
            },
        });
        OKBtn.style.width = '180px';
        buttonContainer.appendChild(OKBtn);
        existWarningPopup.appendChild(buttonContainer);
        POPUP.show(existWarningPopup);
    }
    function buildInjuryLocationDropdown() {
        var opts = {
            label: 'Injury Location',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var iLocDrop = dropdown.build(opts);
        var data = injuryLocations.map(loc => {
            return {
                value: loc.injuryLocationId,
                text: loc.injuryLocation
            };
        });
        data.unshift({
            value: '%',
            text: ''
        });
        dropdown.populate(iLocDrop, data, injuryLocationId);
        return iLocDrop;
    }
    function buildInjuryTypeDropdown() {
        var opts = {
            label: 'Injury Type',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var iTypeDrop = dropdown.build(opts);
        var data = injuryTypes.map(type => {
            return {
                value: type.injuryTypeId,
                text: type.injuryType
            };
        });
        data.unshift({
            value: '%',
            text: ''
        });
        dropdown.populate(iTypeDrop, data, injuryTypeId);
        return iTypeDrop;
    }
    function buildInjuryCauseDropdown() {
        var opts = {
            label: 'Cause of Injury',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var iCauseDrop = dropdown.build(opts);
        var data = injuryCauses.map(type => {
            return {
                value: type.injuryCauseId,
                text: type.injuryCauseDescription
            };
        });
        data.sort((a, b) => {
            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
            return 0;
        });
        data.unshift({
            value: '',
            text: ''
        });
        dropdown.populate(iCauseDrop, data, injuryCauseId);
        iCauseDrop.style.marginTop = '-20px';
        return iCauseDrop;
    }
    function buildRiskOfInjuryDropdown() {
        var opts = {
            label: 'Risk of Serious Injury',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var iRiskDrop = dropdown.build(opts);
        var data = injuryRisks.map(type => {
            return {
                value: type.injuryRiskId,
                text: type.injuryRiskdescription
            };
        });
        data.sort((a, b) => {
            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
            return 0;
        });
        data.unshift({
            value: '',
            text: ''
        });
        dropdown.populate(iRiskDrop, data, injuryRiskId);
        iRiskDrop.style.marginTop = '-20px';
        return iRiskDrop;
    }
    function buildCheckedByCheckbox() {
        var opts = {
            text: 'Checked By Nurse',
            isChecked: checkedByNurse === 'Y' ? true : false
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var checkbox = input.buildCheckbox(opts);
        checkbox.style.marginBottom = '20px';
        return checkbox;
    }
    function buildDetailsInput() {
        var opts = {
            label: 'Details',
            type: 'textarea',
            style: 'secondary',
            value: details
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var dInput = input.build(opts);
        dInput.classList.add('minheight');
        return dInput;
    }
    function buildTreatmentInput() {
        var opts = {
            label: 'Treatment',
            type: 'textarea',
            style: 'secondary',
            value: treatment
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var tInput = input.build(opts);
        tInput.classList.add('minheight');
        return tInput;
    }
    function buildDateCheckedInput() {
        var opts = {
            label: 'Date Checked',
            type: 'date',
            style: 'secondary',
            value: dateChecked
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var dcInput = input.build(opts);
        return dcInput;
    }
    function buildInjuryFormBtns() {
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        injurySaveBtn = button.build({
            text: 'Save',
            type: 'contained',
            style: 'secondary'
        });
        injuryCancelBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary'
        });
        if (!formReadOnly) btnWrap.appendChild(injurySaveBtn);
        btnWrap.appendChild(injuryCancelBtn);
        return btnWrap;
    }
    function buildNewInjuryForm() {
        var form = document.createElement('div');
        form.classList.add('injuryForm');
        injuryLocationDropdown = buildInjuryLocationDropdown();
        injuryTypeDropdown = buildInjuryTypeDropdown();
        injuryCauseDropdown = buildInjuryCauseDropdown();
        riskOfInjuryDropdown = buildRiskOfInjuryDropdown();
        checkedByNurseCheckbox = buildCheckedByCheckbox();
        detailsInput = buildDetailsInput();
        treatmentInput = buildTreatmentInput();
        dateCheckedInput = buildDateCheckedInput();
        injuryFormButtons = buildInjuryFormBtns();
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '5px';
        container.style.width = '100%';
        container.appendChild(injuryLocationDropdown);
        container.appendChild(injuryTypeDropdown);
        container.appendChild(injuryCauseDropdown);
        container.appendChild(riskOfInjuryDropdown);       
        form.appendChild(container);       
        form.appendChild(detailsInput);
        form.appendChild(treatmentInput);
        form.appendChild(checkedByNurseCheckbox);
        dateCheckedInput.style.marginTop = '10px';
        form.appendChild(dateCheckedInput);
        form.appendChild(injuryFormButtons);
        return form;
    }
    function showInjuryDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this record?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                if (!selectedInjuryId.includes('new')) {
                    injuryDeleteData = [];
                    var deletedInjury = injuryData[consumerId][selectedInjuryId];
                    if (!injuryDeleteData[consumerId]) injuryDeleteData[consumerId] = {};
                    injuryDeleteData[consumerId][selectedInjuryId] = deletedInjury;
                    if (injuryDeleteData && injuryDeleteData.length > 0) {
                        var injKeys = Object.keys(injuryDeleteData);
                        injKeys.forEach(injKey => {
                            var keys = Object.keys(injuryDeleteData[injKey]);
                            keys.forEach(key => {
                                incidentTrackingAjax.itDeleteConsumerInjuries(key, () => {
                                    getInjuryData(deleteWarningPopup);
                                    if (isEdit) {
                                        clearSections('injury');
                                    }
                                });
                            });
                        });
                    }
                    else {
                        POPUP.hide(deleteWarningPopup);
                    }
                    selectedInjuryId = undefined;                  
                }
                else {
                    delete injuryData[consumerId][selectedInjuryId];
                    selectedInjuryId = undefined;
                    populateInjuryTable();
                    POPUP.hide(deleteWarningPopup);
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function showInjuryForm(isedit) {
        isEdit = isedit;
        addInjuryBtn.classList.add('hidden');
        var section = document.querySelector('div.injury_section');
        section.innerHTML = '';
        section.appendChild(buildNewInjuryForm());
        setupInjuryFormEvents();
        checkInjuryRequiredFields();

    }
    function buildInjuryTable() {
        injuriesTable = table.build({
            tableId: 'consumerInjuriesTable',
            columnHeadings: ['Injury Type', 'Injury Location', 'Checked By Nurse'],
            endIcon: true
        });
        injuriesTable.addEventListener('click', event => {
            if (event.target.classList.contains('table__row') && !event.target.classList.contains('header')) {
                selectedInjuryId = event.target.id;
                setInjuryFormDataDefaults(injuryData[consumerId][selectedInjuryId]);
                showInjuryForm(true);
            }
            else if (event.target.classList.contains('endIcon')) {
                var row = event.target.closest('.table__row');
                selectedInjuryId = row.id;
                showInjuryDeleteWarning();
            }
        });
        var divContent = document.createElement('div');
        var heading = document.createElement('h4');
        heading.style.marginBottom = '10px';
        heading.textContent = 'Injuries';
        divContent.appendChild(heading);
        divContent.appendChild(injuriesTable);
        divContent.style.paddingBottom = '50px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');       
        addInjuryBtn = button.build({
            text: 'add injury',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: function (e) {
                showInjuryForm(false);
            },
        });
        if (!formReadOnly) {
            btnWrap.appendChild(addInjuryBtn);
        }
        divContent.appendChild(btnWrap);
        var section = document.createElement('div');
        section.classList.add('injury_section');
        section.style.paddingTop = '5px';
        divContent.appendChild(section);
        return divContent;

    }
    function populateInjuryTable() {
        if (!injuryData) {
            injuryData = [];
        }
        if (injuryData.length == 0 || !injuryData[consumerId]) return;
        var tableData = [];
        var keys = Object.keys(injuryData[consumerId]);
        keys.forEach(key => {
            var data = injuryData[consumerId][key];
            var filteredLocations = injuryLocations.filter(iLoc => iLoc.injuryLocationId === data.injuryLocationId);
            var filteredTypes = injuryTypes.filter(iType => iType.injuryTypeId === data.injuryTypeId);
            var injuryLocation = filteredLocations[0].injuryLocation;
            var injuryType = filteredTypes[0].injuryType;
            var nurseChecked = data.checkedByNurse === 'Y' ? 'Yes' : 'No';
            tableData.push({
                id: key,
                values: [injuryLocation, injuryType, nurseChecked],
                endIcon: $.session.incidentTrackingDelete ? `${icons['delete']}` : ''
            });
        });
        table.populate(injuriesTable, tableData);
    }
    function saveConsumerInjuries(saveData) {
       var savePromise = new Promise((fulfill, reject) => {
            incidentTrackingAjax.saveUpdateITConsumerInjuries(saveData, (result) => {
                fulfill(result);
            });
        });
        return savePromise
    }
    //#endregion

    //#region Intervention
    function calculateTotalHours(dirtyStart, dirtyEnd) {
        // must be military time
        if (dirtyStart === '' || dirtyEnd === '' || !dirtyStart || !dirtyEnd) {
            return;
        }
        var startTime = dirtyStart.split(':');
        var endTime = dirtyEnd.split(':');
        var tempDate = new Date();
        var year = tempDate.getFullYear();
        var month = tempDate.getMonth();
        var day = tempDate.getDate();
        var startDate = new Date(year, month, day, startTime[0], startTime[1]);
        var endDate;
        if (dirtyEnd === '00:00') {
            endDate = new Date(year, month, day + 1, endTime[0], endTime[1]);
        } else {
            endDate = new Date(year, month, day, endTime[0], endTime[1]);
        }
        var timeDiff = endDate - startDate;
        var hoursDiff = Math.floor(timeDiff % 86400000 / 3600000);
        var minutesDiff = Math.floor(timeDiff % 86400000 % 3600000 / 60000);
        return `${UTIL.leadingZero(hoursDiff)}:${UTIL.leadingZero(minutesDiff)}`;
    }
    function calculateTimeLength() {
        var stInput = interventionStartTimeInput.querySelector('input');
        var etInput = interventionEndTimeInput.querySelector('input');
        var ttInput = interventionTotalTimeLengthInput.querySelector('input');
        var sTime = stInput.value;
        var eTime = etInput.value;
        if (!sTime || !eTime) {
            if (!sTime) interventionStartTimeInput.classList.remove('error');
            if (!eTime) interventionEndTimeInput.classList.remove('error');
            if (!sTime && !eTime) interventionSaveBtn.classList.remove('disabled');
            return null;
        }
       
        var totalTime = calculateTotalHours(sTime, eTime);        
        if (totalTime.search('-') === -1) {
            ttInput.value = totalTime;
            interventionStartTimeInput.classList.remove('error');
            interventionEndTimeInput.classList.remove('error');
            interventionSaveBtn.classList.remove('disabled');
            return totalTime;
        } else {
            ttInput.value = '';
            interventionStartTimeInput.classList.add('error');
            interventionEndTimeInput.classList.add('error');
            interventionSaveBtn.classList.add('disabled');
            return null;
        }
    }
    function getInterventionTypes() {
        incidentTrackingAjax.getInterventionTypesDropdown(function (res) {
            interventionTypes = res;
        });
    }
    function getInterventionData(deleteWarning) {
        clearTable('consumerInterventionTable');
        incidentTrackingAjax.getitConsumerInterventions(consumerId, SelectedIncidentId, res => {
            interventionData = [];
            if (res && res.length > 0) {
                res.forEach(d => {
                    if (!interventionData[consumerId]) {
                        interventionData[consumerId] = {};
                    }
                    if (!interventionData[consumerId][d.itConsumerInterventionId]) {
                        interventionData[consumerId][d.itConsumerInterventionId] = d;
                        interventionData[consumerId][d.itConsumerInterventionId].updated = false;
                    }
                });
            }
            populateInterventionTable();
            if (deleteWarning) {
                let t = setTimeout(function () {
                    POPUP.hide(deleteWarning);
                    clearTimeout(t);
                }, 500);

            }
        });
    }
    function checkInterventionRequiredFields() {
        var hasErrors = false;
        var interventionTypeSelect = interventionTypeDropdown.querySelector('.dropdown__select');
        if (!interventionTypeSelect.value || interventionTypeSelect.value === '%') {
            interventionTypeDropdown.classList.add('error');
            hasErrors = true;
        } else {
            interventionTypeDropdown.classList.remove('error');
        }       

        //var errors = [...followUpForm.querySelectorAll('.error')];
        if (hasErrors) {
            interventionSaveBtn.classList.add('disabled');
        } else {
            interventionSaveBtn.classList.remove('disabled');         
        }
    }
    function clearInterventionFormDataDefaults() {
        interventionTypeId = undefined;
        interventionStartTime = undefined;
        interventionEndTime = undefined;
        interventionTimeLength = undefined;
        aversive = undefined;
        intereventionNote = undefined;
        lastUpdatedBy = undefined;
        lastUpdatedOn = undefined;
    }
    function setInterventionFormDataDefaults(formData) {
        if (formData) {
            var sTime = formData.startTime.split(':');
            var eTime = formData.stopTime.split(':');
            var tTime = formData.timeLength.split(':');          
            interventionTypeId = formData.interventionType;
            interventionStartTime = `${sTime[0]}:${sTime[1]}`;
            interventionEndTime = `${eTime[0]}:${eTime[1]}`;
            if (tTime[0] !== '') {
                interventionTimeLength = `${tTime[0]}:${tTime[1]}`;
            }
            else {
                interventionTimeLength = '';
            }
            aversive = formData.aversive;
            interventionNotes = formData.interventionNotes;
            lastUpdatedBy = formData.lastUpdatedBy;
            lastUpdatedOn = formData.lastUpdatedOn;
        }
    }
    function setupInterventionFormEvents() {
        var tmpInterventionType;
        var tmpStartTime;
        var tmpEndTime;
        var tmpTimeLength;
        var tmpAversive;
        var tmpNote;
        interventionTypeDropdown.addEventListener('change', e => {
            tmpInterventionType = e.target.value;
            checkInterventionRequiredFields();
        });
        interventionStartTimeInput.addEventListener('change', e => {
            tmpStartTime = e.target.value;            
            tmpTimeLength = calculateTimeLength();
        });
        interventionEndTimeInput.addEventListener('change', e => {
            tmpEndTime = e.target.value;           
            tmpTimeLength = calculateTimeLength();
        });
        aversiveCheckbox.addEventListener('change', e => {
            tmpAversive = e.target.checked ? 'Y' : 'N';
        });
        interventionNotesInput.addEventListener('change', e => {
            tmpNote = e.target.value;
        });

        interventionFormButtons.addEventListener('click', e => {
            if (e.target === interventionSaveBtn) {
                interventionSaveBtn.classList.add('disabled');
                if (!interventionData) {
                    interventionData = [];
                }
                if (!interventionData[consumerId]) {
                    interventionData[consumerId] = {};
                }
                if (!interventionData[consumerId][selectedInterventionId]) {
                    var keys = Object.keys(interventionData[consumerId]);
                    selectedInterventionId = keys.length === 0 ? `new${keys.length}` : `new${keys.length + 1}`;
                    interventionData[consumerId][selectedInterventionId] = {
                        interventionType: '',
                        startTime: '',
                        stopTime: '',
                        timeLength: '',
                        aversive: '',
                        interventionNotes: '',
                        updated: ''
                    };
                }
                if (tmpInterventionType || tmpStartTime || tmpEndTime || tmpTimeLength || tmpAversive || tmpNote) {
                    interventionData[consumerId][selectedInterventionId].updated = true;
                }
                if (tmpInterventionType) interventionData[consumerId][selectedInterventionId].interventionType = tmpInterventionType;
                if (tmpStartTime) interventionData[consumerId][selectedInterventionId].startTime = tmpStartTime;
                if (tmpEndTime) interventionData[consumerId][selectedInterventionId].stopTime = tmpEndTime;
                if (tmpTimeLength) interventionData[consumerId][selectedInterventionId].timeLength = tmpTimeLength;
                if (tmpAversive) interventionData[consumerId][selectedInterventionId].aversive = tmpAversive;
                if (tmpNote) interventionData[consumerId][selectedInterventionId].interventionNotes = tmpNote;
                saveConsumerInterventions().then(() => {
                    selectedInterventionId = undefined;
                    clearInterventionFormDataDefaults();
                    adInterventionBtn.classList.remove('hidden');
                    var section = document.querySelector('div.intervention_section');
                    section.innerHTML = '';
                    getInterventionData();
                    successfulSave.show();
                    interventionSaveBtn.classList.remove('disabled');
                    setTimeout(function () { successfulSave.hide(); }, 2000);
                    return;
                });
            }
            if (e.target === interventionCancelBtn) {
                selectedInterventionId = undefined;
                clearInterventionFormDataDefaults();
                adInterventionBtn.classList.remove('hidden');
                var section = document.querySelector('div.intervention_section');
                section.innerHTML = '';
                return;
                return;
            }
        });
    }
    function buildInterventionTypeDropdown() {
        var opts = {
            label: 'Intervention Type',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var iTypeDrop = dropdown.build(opts);
        var data = interventionTypes.map(it => {
            return {
                value: it.interventionTypeId,
                text: it.description
            };
        });
        data.unshift({
            value: '%',
            text: ''
        });
        dropdown.populate(iTypeDrop, data, interventionTypeId);
        return iTypeDrop;
    }
    function buildInterventionStartTimeInput() {
        var opts = {
            label: 'Start Time',
            type: 'time',
            style: 'secondary',
            value: interventionStartTime
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var stInput = input.build(opts);
        return stInput;
    }
    function buildInterventionEndTimeInput() {
        var opts = {
            label: 'End Time',
            type: 'time',
            style: 'secondary',
            value: interventionEndTime
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var etInput = input.build(opts);
        return etInput;
    }
    function buildTotalTimeInput() {
        var opts = {
            label: 'Total Time',
            type: 'text',
            style: 'secondary',
            readonly: true,
            value: interventionTimeLength
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var etInput = input.build(opts);
        return etInput;
    }
    function buildAversiveCheckbox() {
        var opts = {
            text: 'Aversive',
            isChecked: aversive === 'Y' ? true : false
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var checkbox = input.buildCheckbox(opts);
        return checkbox;
    }
    function buildInterventionNotesInput() {
        var opts = {
            label: 'Notes',
            type: 'textarea',
            style: 'secondary',
            value: interventionNotes
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var nInput = input.build(opts);
        nInput.classList.add('minheight');
        return nInput;
    }
    function buildInterventionFormBtns() {
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        interventionSaveBtn = button.build({
            id:'saveInterventionBtn',
            text: 'Save',
            type: 'contained',
            style: 'secondary'
        });
        interventionCancelBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary'
        });
        if (!formReadOnly) btnWrap.appendChild(interventionSaveBtn);
        btnWrap.appendChild(interventionCancelBtn);
        return btnWrap;
    }
    function buildNewInterventionForm() {
        var form = document.createElement('div');
        form.classList.add('interventionForm');
        interventionTypeDropdown = buildInterventionTypeDropdown();
        interventionTypeDropdown.style.width = '100%';
        interventionStartTimeInput = buildInterventionStartTimeInput();
        interventionEndTimeInput = buildInterventionEndTimeInput();
        interventionTotalTimeLengthInput = buildTotalTimeInput();
        aversiveCheckbox = buildAversiveCheckbox();
        aversiveCheckbox.style.marginBottom = '25px';
        interventionNotesInput = buildInterventionNotesInput();
        interventionFormButtons = buildInterventionFormBtns();
        form.appendChild(interventionTypeDropdown);
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '5px';
        container.style.width = '100%';
        container.appendChild(interventionStartTimeInput);
        container.appendChild(interventionEndTimeInput)
        form.appendChild(container);
        form.appendChild(interventionTotalTimeLengthInput);
        form.appendChild(aversiveCheckbox);
        form.appendChild(interventionNotesInput);
        form.appendChild(interventionFormButtons);
        return form;
    }
    function showInterventionForm(isedit) {
        isEdit = isedit;
        adInterventionBtn.classList.add('hidden');
        var section = document.querySelector('div.intervention_section');
        section.innerHTML = '';
        section.appendChild(buildNewInterventionForm());

        setupInterventionFormEvents();
        checkInterventionRequiredFields();
    }
    function showInterventionDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this record?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                if (!selectedInterventionId.includes('new')) {
                    interventionDeleteData = [];
                    var deletedIntervention = interventionData[consumerId][selectedInterventionId];
                    if (!interventionDeleteData[consumerId]) interventionDeleteData[consumerId] = {};
                    interventionDeleteData[consumerId][selectedInterventionId] = deletedIntervention;
                    if (interventionDeleteData && interventionDeleteData.length > 0) {
                        var intKeys = Object.keys(interventionDeleteData);
                        intKeys.forEach(intKey => {
                            var keys = Object.keys(interventionDeleteData[intKey]);
                            keys.forEach(key => {
                                incidentTrackingAjax.itDeleteConsumerInterventions(key, () => {
                                    getInterventionData(deleteWarningPopup);
                                    if (isEdit) {
                                        clearSections('intervention');
                                    }
                                });
                            });
                        });
                    }
                    else {
                        POPUP.hide(deleteWarningPopup);
                    }
                    selectedInterventionId = undefined;                  
                }
                else {
                    delete interventionData[consumerId][selectedInterventionId];
                    selectedInterventionId = undefined;
                    populateInterventionTable();
                    POPUP.hide(deleteWarningPopup);
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function buildInterventionTable() {
        interventionTable = table.build({
            tableId: 'consumerInterventionTable',
            columnHeadings: ['Intervention Type', 'Time Length', 'Aversive'],
            endIcon: true
        });
        interventionTable.addEventListener('click', event => {
            if (event.target.classList.contains('table__row') && !event.target.classList.contains('header')) {
                selectedInterventionId = event.target.id;
                setInterventionFormDataDefaults(interventionData[consumerId][selectedInterventionId]);
                showInterventionForm(true);
            }
            else if (event.target.classList.contains('endIcon')) {
                var row = event.target.closest('.table__row');
                selectedInterventionId = row.id;
                showInterventionDeleteWarning();
            }
        });
        var divContent = document.createElement('div');
        var heading = document.createElement('h4');
        heading.style.marginBottom = '10px';
        heading.textContent = 'Interventions';
        divContent.appendChild(heading);
        divContent.appendChild(interventionTable);
        divContent.style.paddingBottom = '50px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');       
        adInterventionBtn = button.build({
            text: 'add intervention',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: function (e) {
                showInterventionForm(false);
            },
        });
        if (!formReadOnly) {
            btnWrap.appendChild(adInterventionBtn);
        }
        divContent.appendChild(btnWrap);
        var section = document.createElement('div');
        section.classList.add('intervention_section');
        section.style.paddingTop = '5px';
        divContent.appendChild(section);
        return divContent;
    }
    function populateInterventionTable() {
        if (!interventionData) {
            interventionData = [];
        }
        if (interventionData.length == 0 || !interventionData[consumerId]) return;
        var tableData = [];
        var keys = Object.keys(interventionData[consumerId]);
        keys.forEach(key => {
            var data = interventionData[consumerId][key];
            var filteredInterventionTypes = interventionTypes.filter(it => it.interventionTypeId === data.interventionType);
            var interventionType = filteredInterventionTypes[0].description;
            var timeLength = data.timeLength.split(':');
            if (timeLength[0] && timeLength[1]) {
                timeLength = `${timeLength[0]}:${timeLength[1]}`;
            }
            else {
                timeLength = '';
            }
            var aversive = data.aversive === 'Y' ? 'Yes' : 'No';
            tableData.push({
                id: key,
                values: [interventionType, timeLength, aversive],
                endIcon: $.session.incidentTrackingDelete ? `${icons['delete']}` : ''
            });
        });
        table.populate(interventionTable, tableData);

    }
    function saveConsumerInterventions() {
        var saveData = {
            token: $.session.Token,
            consumerInvolvedId: consumerInvolementId,
            itConsumerInterventionIdArray: [],
            aversiveArray: [],
            itConsumerInterventionTypeIdArray: [],
            notesArray: [],
            startTimeArray: [],
            stopTimeArray: [],
            timeLengthArray: []
        };
        var idKeys = Object.keys(interventionData[consumerId]);
        idKeys.forEach(idKey => {
            var iData = interventionData[consumerId][idKey];
            if (!iData.updated) return;
            var isNew = idKey.includes('new');
            var itConsumerInterventionId = isNew ? '' : idKey;
            var aversive = iData.aversive ? iData.aversive : '';
            var interventionType = iData.interventionType ? iData.interventionType : '';
            var interventionNotes = iData.interventionNotes ? UTIL.removeUnsavableNoteText(iData.interventionNotes) : '';
            var startTime = iData.startTime ? iData.startTime : '';
            var stopTime = iData.stopTime ? iData.stopTime : '';
            var timeLength = iData.timeLength ? iData.timeLength : '';
            saveData.itConsumerInterventionIdArray.push(itConsumerInterventionId);
            saveData.aversiveArray.push(aversive);
            saveData.itConsumerInterventionTypeIdArray.push(interventionType);
            saveData.notesArray.push(interventionNotes);
            saveData.startTimeArray.push(startTime);
            saveData.stopTimeArray.push(stopTime);
            saveData.timeLengthArray.push(timeLength);
        });
        var savePromise = new Promise((fulfill, reject) => {
            incidentTrackingAjax.saveUpdateITConsumerInterventions(saveData, () => {
                fulfill();
            });
        });
        return savePromise;
    }
    //#endregion

    //#region Report
    function getReportData(deleteWarning) {
        clearTable('consumerReportingTable');
        incidentTrackingAjax.getitConsumerReporting(consumerId, SelectedIncidentId, res => {
            reportingData = [];
            if (res && res.length > 0) {
                res.forEach(d => {
                    if (!reportingData[consumerId]) {
                        reportingData[consumerId] = {};
                    }
                    if (!reportingData[consumerId][d.itConsumerReportId]) {
                        reportingData[consumerId][d.itConsumerReportId] = d;
                        reportingData[consumerId][d.itConsumerReportId].updated = false;

                        // format dates
                        if (reportingData[consumerId][d.itConsumerReportId].dateReported) {
                            var dateReported = reportingData[consumerId][d.itConsumerReportId].dateReported.split(' ')[0];
                            reportingData[consumerId][d.itConsumerReportId].dateReported = UTIL.formatDateToIso(dateReported);
                        }
                    }
                });
            }
            populateReportTable();
            if (deleteWarning) {
                let t = setTimeout(function () {
                    POPUP.hide(deleteWarning);
                    clearTimeout(t);
                }, 500);

            }
        });
    }
    function getReportDropdownData() {
        incidentTrackingAjax.getitReportingCategories(function (res) {
            reportingCategories = res;
        });
    }
    function checkReportRequiredFields() {
        var hasErrors = false;
        var reportCatSelect = reportingCategoryDropdown.querySelector('.dropdown__select');
        if (!reportCatSelect.value || reportCatSelect.value === '%') {
            reportingCategoryDropdown.classList.add('error');
            hasErrors = true;
        } else {
            reportingCategoryDropdown.classList.remove('error');
        }
        var dateInput = reportDateInput.querySelector('input');
        if (!dateInput.value) {
            reportDateInput.classList.add('error');
            hasErrors = true;
        } else {
            reportDateInput.classList.remove('error');
        }
        if (hasErrors) {
            reportSaveBtn.classList.add('disabled');
        } else {
            reportSaveBtn.classList.remove('disabled');
        }
    }
    function clearReportFormDataDefaults() {
        dateReported = undefined;
        reportTime = undefined;
        reportBy = undefined;
        reportMethod = undefined;
        reportTo = undefined;
        reportingCategoryId = undefined;
        reportNotes = undefined;
    }
    function setReportFormDataDefaults(formData) {
       
        if (formData) {
            dateReported = formData.dateReported;
            reportTime = formData.timeReported; // todo
            reportBy = formData.reportBy;
            reportMethod = formData.reportMethod;
            reportTo = formData.reportTo;
            reportingCategoryId = formData.reportingCategoryID;
            reportNotes = formData.notes;
        }
    }
    function setupReportFormEvents() {
        var tmpReportingCategoryId;
        var tmpReportedBy;
        var tmpReportedTo;
        var tmpReportMethod;
        var tmpReportDate;
        var tmpReportTime;
        var tmpNote;
        reportingCategoryDropdown.addEventListener('change', e => {
            tmpReportingCategoryId = e.target.value;
            checkReportRequiredFields();
        });
        reportedByInput.addEventListener('change', e => {
            tmpReportedBy = e.target.value;
        });
        reportedToInput.addEventListener('change', e => {
            tmpReportedTo = e.target.value;
        });
        reportMethodInput.addEventListener('change', e => {
            tmpReportMethod = e.target.value;
        });
        reportDateInput.addEventListener('change', e => {
            tmpReportDate = e.target.value;
            checkReportRequiredFields();
        });
        reportTimeInput.addEventListener('change', e => {
            tmpReportTime = e.target.value;
        });
        reportNotesInput.addEventListener('change', e => {
            tmpNote = e.target.value;
        });

        reportFormButtons.addEventListener('click', e => {
            if (e.target === reportSaveBtn) {
                reportSaveBtn.classList.add('disabled');
                if (!reportingData || !reportingData[consumerId]) {
                    reportingData[consumerId] = {};
                }
                if (!reportingData[consumerId][selectedReportId]) {
                    var keys = Object.keys(reportingData[consumerId]);
                    selectedReportId = keys.length === 0 ? `new${keys.length}` : `new${keys.length + 1}`;
                    reportingData[consumerId][selectedReportId] = {
                        reportingCategoryID: '',
                        reportBy: '',
                        reportTo: '',
                        reportMethod: '',
                        dateReported: '',
                        notes: '',
                        updated: ''
                    };
                }
                if (tmpReportingCategoryId || tmpReportedBy || tmpReportedTo || tmpReportMethod || tmpReportDate || tmpReportTime || tmpNote) {
                    reportingData[consumerId][selectedReportId].updated = true;
                }
                if (tmpReportingCategoryId) reportingData[consumerId][selectedReportId].reportingCategoryID = tmpReportingCategoryId;
                if (tmpReportedBy) reportingData[consumerId][selectedReportId].reportBy = tmpReportedBy;
                if (tmpReportedTo) reportingData[consumerId][selectedReportId].reportTo = tmpReportedTo;
                if (tmpReportMethod) reportingData[consumerId][selectedReportId].reportMethod = tmpReportMethod;
                if (tmpReportDate) reportingData[consumerId][selectedReportId].dateReported = tmpReportDate;
                if (tmpReportTime) reportingData[consumerId][selectedReportId].timeReported = tmpReportTime;
                if (tmpNote) reportingData[consumerId][selectedReportId].notes = tmpNote;
                saveConsumerReports().then(() => {
                    selectedReportId = undefined;
                    var section = document.querySelector('div.report_section');
                    section.innerHTML = '';
                    clearReportFormDataDefaults();
                    addReportBtn.classList.remove('hidden');
                    getReportData();
                    successfulSave.show();
                    reportSaveBtn.classList.remove('disabled');
                    setTimeout(function () { successfulSave.hide(); }, 2000);
                    return;
                });
            }
            if (e.target === reportCancelBtn) {
                selectedReportId = undefined;
                var section = document.querySelector('div.report_section');
                section.innerHTML = '';
                clearReportFormDataDefaults();
                addReportBtn.classList.remove('hidden');
                return;
            }
        });
    }
    function buildReportingCategoryDropdown() {
        var opts = {
            label: 'Reporting To Category',
            style: 'secondary'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rCatDrop = dropdown.build(opts);
        var data = reportingCategories.map(cat => {
            return {
                value: cat.itReportingCategoryId,
                text: cat.itReportingCategoryName
            };
        });
        data.unshift({
            value: '%',
            text: ''
        });
        dropdown.populate(rCatDrop, data, reportingCategoryId);
        return rCatDrop;
    }
    function buildReportedByInput() {
        var opts = {
            label: 'Reported By',
            type: 'text',
            style: 'secondary',
            value: reportBy
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rbInput = input.build(opts);
        return rbInput;
    }
    function buildReportedToInput() {
        var opts = {
            label: 'Reported To',
            type: 'text',
            style: 'secondary',
            value: reportTo
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rtInput = input.build(opts);
        rtInput.style.marginTop = '-20px';
        return rtInput;
    }
    function showReportDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this record?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                if (!selectedReportId.includes('new')) {
                    reportingDeleteData = [];
                    var deletedReport = reportingData[consumerId][selectedReportId];
                    if (!reportingDeleteData[consumerId]) reportingDeleteData[consumerId] = {};
                    reportingDeleteData[consumerId][selectedReportId] = deletedReport;
                    if (reportingDeleteData && reportingDeleteData.length > 0) {
                        var repKeys = Object.keys(reportingDeleteData);
                        repKeys.forEach(repKey => {
                            var keys = Object.keys(reportingDeleteData[repKey]);
                            keys.forEach(key => {
                                incidentTrackingAjax.itDeleteConsumerReporting(key, () => {
                                    getReportData(deleteWarningPopup);
                                    if (isEdit) {
                                        clearSections('report');
                                    }
                                });
                            });
                        });
                    }
                    else {
                        POPUP.hide(deleteWarningPopup);
                    }
                    selectedReportId = undefined;                    
                }
                else {
                    delete reportingData[consumerId][selectedReportId];
                    populateReportTable();
                    selectedReportId = undefined;
                    POPUP.hide(deleteWarningPopup);
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function buildReportTable() {
        reportTable = table.build({
            tableId: 'consumerReportingTable',
            columnHeadings: ['Reporting Category', 'Reported Date', 'Reported By'],
            endIcon: true
        });
        reportTable.addEventListener('click', event => {
            if (event.target.classList.contains('table__row') && !event.target.classList.contains('header')) {
                selectedReportId = event.target.id;
                setReportFormDataDefaults(reportingData[consumerId][selectedReportId]);
                showReportForm(true);               
            }
            else if (event.target.classList.contains('endIcon')) {
                var row = event.target.closest('.table__row');
                selectedReportId = row.id;
                showReportDeleteWarning();
            }
        });
        var divContent = document.createElement('div');
        var heading = document.createElement('h4');
        heading.style.marginBottom = '10px';
        heading.textContent = 'Reporting';
        divContent.appendChild(heading);
        divContent.appendChild(reportTable);
        divContent.style.paddingBottom = '50px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');      
        addReportBtn = button.build({
            text: 'add reporting',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: function (e) {
                showReportForm(false);
            },
        });
        if (!formReadOnly) {
            btnWrap.appendChild(addReportBtn);
        }
        divContent.appendChild(btnWrap);
        var section = document.createElement('div');
        section.classList.add('report_section');
        section.style.paddingTop = '5px';
        divContent.appendChild(section);
        return divContent;
    }
    function buildReportMethodInput() {
        var opts = {
            label: 'Report Method',
            type: 'text',
            style: 'secondary',
            value: reportMethod
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rmInput = input.build(opts);
        rmInput.style.marginTop = '-20px';
        return rmInput;
    }
    function buildReportedDateInput() {
        var opts = {
            label: 'Date Reported',
            type: 'date',
            style: 'secondary',
            value: dateReported
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rdInput = input.build(opts);
        rdInput.style.marginTop = '-20px';
        return rdInput;
    }
    function buildReportedTimeInput() {
        var opts = {
            label: 'Reported Time',
            type: 'time',
            style: 'secondary',
            value: reportTime
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rtInput = input.build(opts);
        rtInput.style.marginTop = '-20px';
        return rtInput;
    }
    function buildReportedNotesInput() {
        var opts = {
            label: 'Notes',
            type: 'textarea',
            style: 'secondary',
            value: reportNotes
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var nInput = input.build(opts);
        nInput.classList.add('minheight');
        return nInput;
    }
    function buildNewReportingForm() {
        var form = document.createElement('div');
        form.classList.add('reportForm');
        reportingCategoryDropdown = buildReportingCategoryDropdown();
        reportedByInput = buildReportedByInput();
        reportedToInput = buildReportedToInput();
        reportMethodInput = buildReportMethodInput();
        reportDateInput = buildReportedDateInput();
        reportTimeInput = buildReportedTimeInput();
        reportNotesInput = buildReportedNotesInput();
        reportFormButtons = buildReportFormBtns();
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '5px';
        container.style.width = '100%';
        container.appendChild(reportingCategoryDropdown);
        container.appendChild(reportedByInput);
        container.appendChild(reportedToInput);
        container.appendChild(reportMethodInput);
        container.appendChild(reportDateInput);
        container.appendChild(reportTimeInput);      
        form.appendChild(container);
        form.appendChild(reportNotesInput);
        form.appendChild(reportFormButtons);
        return form;
    }
    function showReportForm(isedit) {
        isEdit = isedit;
        var section = document.querySelector('div.report_section');
        section.innerHTML = '';
        section.appendChild(buildNewReportingForm());
        addReportBtn.classList.add('hidden');
        setupReportFormEvents();
        checkReportRequiredFields();
    }
    function buildReportFormBtns() {
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        reportSaveBtn = button.build({
            id:'saveReportBtn',
            text: 'Save',
            type: 'contained',
            style: 'secondary'
        });
        reportCancelBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary'
        });
        if (!formReadOnly) btnWrap.appendChild(reportSaveBtn);
        btnWrap.appendChild(reportCancelBtn);
        return btnWrap;
    }
    function populateReportTable() {

        if (!reportingData) {
            reportingData = [];
        }
        if (reportingData.length == 0 || !reportingData[consumerId]) return;
        var tableData = [];
        var keys = Object.keys(reportingData[consumerId]);
        keys.forEach(key => {
            var data = reportingData[consumerId][key];
            var filteredCategories = reportingCategories.filter(rCat => rCat.itReportingCategoryId === data.reportingCategoryID);
            var reportedCategory = filteredCategories[0].itReportingCategoryName;
            var date = data.dateReported ? data.dateReported.split(' ')[0] : '';
            date = date ? UTIL.formatDateFromIso(date) : date;
            var reportBy = data.reportBy;
            tableData.push({
                id: key,
                values: [reportedCategory, date, reportBy],
                endIcon: $.session.incidentTrackingDelete ? `${icons['delete']}` : ''
            });
        });
        table.populate(reportTable, tableData);

    }
    function saveConsumerReports() {
        var saveData = {
            token: $.session.Token,
            consumerInvolvedId: consumerInvolementId,
            consumerReportIdArray: [],
            reportDateArray: [],
            reportTimeArray: [],
            reportingCategoryIdArray: [],
            reportToArray: [],
            reportByArray: [],
            reportMethodArray: [],
            notesArray: []
        };
        var idKeys = Object.keys(reportingData[consumerId]);
        idKeys.forEach(idKey => {
            var rData = reportingData[consumerId][idKey];
            if (!rData.updated) return;
            var isNew = idKey.includes('new');
            var itConsumerReportId = isNew ? '' : idKey;
            var dateReported = rData.dateReported ? rData.dateReported : '';
            var timeReported = rData.timeReported ? rData.timeReported : '';
            var reportingCategoryID = rData.reportingCategoryID ? rData.reportingCategoryID : '';
            var reportTo = rData.reportTo ? UTIL.removeUnsavableNoteText(rData.reportTo) : '';
            var reportBy = rData.reportBy ? UTIL.removeUnsavableNoteText(rData.reportBy) : '';
            var reportMethod = rData.reportMethod ? UTIL.removeUnsavableNoteText(rData.reportMethod) : '';
            var notes = rData.notes ? UTIL.removeUnsavableNoteText(rData.notes) : '';
            saveData.consumerReportIdArray.push(itConsumerReportId);
            saveData.reportDateArray.push(dateReported);
            saveData.reportTimeArray.push(timeReported);
            saveData.reportingCategoryIdArray.push(reportingCategoryID);
            saveData.reportToArray.push(reportTo);
            saveData.reportByArray.push(reportBy);
            saveData.reportMethodArray.push(reportMethod);
            saveData.notesArray.push(notes);
        });
        var savePromise = new Promise((fulfill, reject) => {
            incidentTrackingAjax.saveUpdateITConsumerReporting(saveData, () => {
                fulfill();
            });
        });
        return savePromise;
    }
    //#endregion

    //#region Review
    function getReviewData(deleteWarning) {
        clearTable('consumerReviewTable');
        incidentTrackingAjax.getitConsumerReviews(consumerId, SelectedIncidentId, res => {
            reviewData = [];
            if (res && res.length > 0) {
                res.forEach(d => {
                    if (!reviewData[consumerId]) {
                        reviewData[consumerId] = {};
                    }
                    if (!reviewData[consumerId][d.itConsumerReviewId]) {
                        reviewData[consumerId][d.itConsumerReviewId] = d;
                        reviewData[consumerId][d.itConsumerReviewId].updated = false;

                        // format dates
                        if (reviewData[consumerId][d.itConsumerReviewId].reviewedDate) {
                            var reviewDate = reviewData[consumerId][d.itConsumerReviewId].reviewedDate.split(' ')[0];
                            reviewData[consumerId][d.itConsumerReviewId].reviewedDate = UTIL.formatDateToIso(reviewDate);
                        }
                    }
                });
            }
            populateReviewTable();
            if (deleteWarning) {
                let t = setTimeout(function () {
                    POPUP.hide(deleteWarning);
                    clearTimeout(t);
                }, 500);

            }
        });
    }
    function getReviewDropdownData() {
        incidentTrackingAjax.getReviewedByDropdown(function (res) {
            reviewedByDropdownData = res;
        });
    }
    function checkReviewedRequiredFields() {
        var hasErrors = false;
        var dateInput = reviewDateInput.querySelector('input');
        if (!dateInput.value) {
            reviewDateInput.classList.add('error');
            hasErrors = true;
        } else {
            reviewDateInput.classList.remove('error');
        }
        if (hasErrors) {
            reviewedSaveBtn.classList.add('disabled');
        } else {
            reviewedSaveBtn.classList.remove('disabled');
        }
    }
    function clearReviewedFormDataDefaults() {
        reviewedDate = undefined;
        reviewedById = undefined;
        reviewNotes = undefined;
    }
    function setReviewedFormDataDefaults(formData) {
        if (formData) {
            reviewedDate = formData.reviewedDate;
            reviewedById = formData.reviewedBy;
            reviewNotes = formData.notes;
        }
    }
    function setupReviewedFormEvents() {
        var tmpReviewDate;
        var tmpReviewedBy;
        var tmpNote;
        reviewDateInput.addEventListener('change', e => {
            tmpReviewDate = e.target.value;
            checkReviewedRequiredFields();
        });
        reviewedByDropdown.addEventListener('change', e => {
            tmpReviewedBy = e.target.value;
        });
        reviewednotesInput.addEventListener('change', e => {
            tmpNote = e.target.value;
        });

        reviewedformButtons.addEventListener('click', e => {
            if (e.target === reviewedSaveBtn) {
                reviewedSaveBtn.classList.add('disabled');
                if (!reviewData || !reviewData[consumerId]) {
                    reviewData[consumerId] = {};
                }
                if (!reviewData[consumerId][selectedReviewId]) {
                    var keys = Object.keys(reviewData[consumerId]);
                    selectedReviewId = keys.length === 0 ? `new${keys.length}` : `new${keys.length + 1}`;
                    reviewData[consumerId][selectedReviewId] = {
                        reviewedDate: '',
                        reviewedBy: '',
                        notes: '',
                        updated: ''
                    };
                }
                if (tmpReviewDate || tmpReviewedBy || tmpNote) {
                    reviewData[consumerId][selectedReviewId].updated = true;
                }
                if (tmpReviewDate) {
                    reviewData[consumerId][selectedReviewId].reviewedDate = tmpReviewDate;
                }
                if (tmpReviewedBy) {
                    reviewData[consumerId][selectedReviewId].reviewedBy = tmpReviewedBy;
                }
                const currentReviewedBy = reviewData[consumerId][selectedReviewId].reviewedBy;
                if ($.session.incidentTrackingReviewedBy && (!currentReviewedBy || currentReviewedBy === '')) {
                    reviewData[consumerId][selectedReviewId].reviewedBy = $.session.PeopleId;
                }
                if (tmpNote) {
                    reviewData[consumerId][selectedReviewId].notes = tmpNote;
                }
                saveConsumerReviews().then(() => {
                    selectedReviewId = undefined;
                    var section = document.querySelector('div.review_section');
                    section.innerHTML = '';
                    clearReviewedFormDataDefaults();
                    newReviewBtn.classList.remove('hidden');
                    getReviewData();
                    successfulSave.show();
                    reviewedSaveBtn.classList.remove('disabled');
                    setTimeout(function () { successfulSave.hide(); }, 2000);
                    return;
                });
            }
            if (e.target === reviewedCancelBtn) {
                selectedReviewId = undefined;
                var section = document.querySelector('div.review_section');
                section.innerHTML = '';
                clearReviewedFormDataDefaults();
                newReviewBtn.classList.remove('hidden');
                return;
            }
        });
    }
    function buildReviewDateInput() {
        var opts = {
            label: 'Review Date',
            type: 'date',
            style: 'secondary',
            value: reviewedDate
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var dateInput = input.build(opts);
        return dateInput;
    }
    function buildReviewedByDropdown() {
        var opts = {
            label: 'Reviewed By',
            style: 'secondary',
            classNames: 'reviewedBy'
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var rbDrop = dropdown.build(opts);
        var data = reviewedByDropdownData.map(rb => {
            return {
                value: rb.employeeId,
                text: rb.employeeName
            };
        });
        data.unshift({
            value: '%',
            text: ''
        });
        if (!$.session.incidentTrackingReviewedBy) {
            dropdown.populate(rbDrop, data, reviewedById);
        } else {
            if (isEdit) {
                dropdown.populate(rbDrop, data, reviewedById);
            } else {
                dropdown.populate(rbDrop, data, $.session.PeopleId);
            }
            input.disableInputField(rbDrop);
        }
        return rbDrop;
    }
    function buildReviewedNotesInput() {
        var opts = {
            label: 'Notes',
            type: 'textarea',
            style: 'secondary',
            value: reviewNotes
        };
        if (isEdit && formReadOnly) {
            opts.readonly = true;
        }
        var nInput = input.build(opts);
        nInput.classList.add('minheight');
        return nInput;
    }
    function buildReviewedFormBtns() {
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        reviewedSaveBtn = button.build({
            id: 'saveReviewBtn',
            text: 'Save',
            type: 'contained',
            style: 'secondary'
        });
        reviewedCancelBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary'
        });
        if (!formReadOnly) btnWrap.appendChild(reviewedSaveBtn);
        btnWrap.appendChild(reviewedCancelBtn);
        return btnWrap;
    }
    function buildNewReviewForm() {
        var form = document.createElement('div');
        form.classList.add('reviewForm');
        reviewDateInput = buildReviewDateInput();
        reviewedByDropdown = buildReviewedByDropdown();
        reviewednotesInput = buildReviewedNotesInput();
        reviewedformButtons = buildReviewedFormBtns();
        var container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = '1fr 1fr';
        container.style.gap = '20px';
        container.style.marginBottom = '5px';
        container.style.width = '100%';
        container.appendChild(reviewDateInput);
        container.appendChild(reviewedByDropdown);
        form.appendChild(container);
        form.appendChild(reviewednotesInput);
        form.appendChild(reviewedformButtons);
        return form;
    }
    function showReviewedForm(isedit) {
        isEdit = isedit;
        var section = document.querySelector('div.review_section');
        section.innerHTML = '';
        section.appendChild(buildNewReviewForm());
        newReviewBtn.classList.add('hidden');
        setupReviewedFormEvents();
        checkReviewedRequiredFields();
    }
    function showReviewDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this record?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                if (!selectedReviewId.includes('new')) {
                    reviewDeleteData = [];
                    var deletedReview = reviewData[consumerId][selectedReviewId];
                    if (!reviewDeleteData[consumerId]) reviewDeleteData[consumerId] = {};
                    reviewDeleteData[consumerId][selectedReviewId] = deletedReview;
                    if (reviewDeleteData && reviewDeleteData.length > 0) {
                        var revKeys = Object.keys(reviewDeleteData);
                        revKeys.forEach(revKey => {
                            var keys = Object.keys(reviewDeleteData[revKey]);
                            keys.forEach(key => {
                                incidentTrackingAjax.itDeleteConsumerReviews(key, () => {
                                    getReviewData(deleteWarningPopup);
                                    if (isEdit) {
                                        clearSections('review');
                                    }
                                });
                            });
                        });
                    }
                    else {
                        POPUP.hide(deleteWarningPopup)
                    }
                    selectedReviewId = undefined;
                    newReviewBtn.classList.remove('hidden');
                   
                }
                else {
                    delete reviewData[consumerId][selectedReviewId];
                    selectedReviewId = undefined;
                    populateReviewTable();
                    newReviewBtn.classList.remove('hidden');
                    POPUP.hide(deleteWarningPopup);
                }

            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function buildReviewTable() {
        reviewTable = table.build({
            tableId: 'consumerReviewTable',
            columnHeadings: ['Reviewed By', 'Reviewed Date', ''],
            endIcon: true
        });
        reviewTable.addEventListener('click', event => {
            if (event.target.classList.contains('table__row') && !event.target.classList.contains('header')) {
                selectedReviewId = event.target.id;
                setReviewedFormDataDefaults(reviewData[consumerId][selectedReviewId]);
                showReviewedForm(true);               
            }
            else if (event.target.classList.contains('endIcon')) {
                var row = event.target.closest('.table__row');
                selectedReviewId = row.id;
                showReviewDeleteWarning();
            }
        });
        var divContent = document.createElement('div');
        var heading = document.createElement('h4');
        heading.style.marginBottom = '10px';
        heading.textContent = 'Reviews';
        divContent.appendChild(heading);
        divContent.appendChild(reviewTable);
        divContent.style.paddingBottom = '50px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');       
        newReviewBtn = button.build({
            text: 'add review',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: function (e) {
                showReviewedForm(false);
            },
        });
        if (!formReadOnly) {
            btnWrap.appendChild(newReviewBtn);
        }
        divContent.appendChild(btnWrap);
        var section = document.createElement('div');
        section.classList.add('review_section');
        section.style.paddingTop = '5px';
        divContent.appendChild(section);
        return divContent;
    }
    function populateReviewTable() {
        if (!reviewData) {
            reviewData = [];
        }
        if (!reviewData[consumerId] || reviewData.length == 0) return;
        var tableData = [];
        var keys = Object.keys(reviewData[consumerId]);
        keys.forEach(key => {
            var data = reviewData[consumerId][key];
            var reviewedBy = reviewedByDropdownData?.find(d => d.employeeId === data.reviewedBy);
            reviewedBy = reviewedBy ? reviewedBy.employeeName : '';
            var dateReviewed = UTIL.formatDateFromIso(data.reviewedDate);
            tableData.push({
                id: key,
                values: [reviewedBy, dateReviewed, ''],
                endIcon: $.session.incidentTrackingDelete ? `${icons['delete']}` : ''
            });
        });
        table.populate(reviewTable, tableData);

    }
    function saveConsumerReviews() {
        var saveData = {
            token: $.session.Token,
            consumerInvolvedId: consumerInvolementId,
            itConsumerReviewIdArray: [],
            reviewedByArray: [],
            reviewedDateArray: [],
            noteArray: []
        };
        var idKeys = Object.keys(reviewData[consumerId]);
        idKeys.forEach(idKey => {
            var rData = reviewData[consumerId][idKey];
            if (!rData.updated) return;
            var isNew = idKey.includes('new');
            var itConsumerReviewId = isNew ? '' : idKey;
            var reviewedBy = rData.reviewedBy ? rData.reviewedBy : '';
            var reviewedDate = rData.reviewedDate ? rData.reviewedDate : '';
            var notes = rData.notes ? UTIL.removeUnsavableNoteText(rData.notes) : '';
            saveData.itConsumerReviewIdArray.push(itConsumerReviewId);
            saveData.reviewedByArray.push(reviewedBy);
            saveData.reviewedDateArray.push(reviewedDate);
            saveData.noteArray.push(notes);
        });
        var savePromise = new Promise((fulfill, reject) => {
            incidentTrackingAjax.saveUpdateITConsumerReviews(saveData, () => {
                fulfill();
            });
        });
        return savePromise;
    }
    //#endregion

    function showConsumerDeleteWarning() {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to remove this individual from this incident?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                document.getElementById('btnRemoveConsumer').classList.add('disabled');
                deleteConsumerData();
                
                var timer1 = setTimeout(function () {
                    POPUP.hide(deleteWarningPopup);
                    clearTimeout(timer1);                    
                }, 2000);
              
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function deleteConsumerData() {
        if (followUpsData) {
            var fuKeys = Object.keys(followUpsData);
            fuKeys.forEach(fuKey => {
                var keys = Object.keys(followUpsData[fuKey]);
                keys.forEach(key => {
                    incidentTrackingAjax.itDeleteConsumerFollowUp(key, () => {
                        getFollowupsdata();
                        clearSections('followup');
                    });
                });
            });
        }
        if (injuryData) {
            var injKeys = Object.keys(injuryData);
            injKeys.forEach(injKey => {
                var keys = Object.keys(injuryData[injKey]);
                keys.forEach(key => {
                    incidentTrackingAjax.itDeleteConsumerInjuries(key, () => { getInjuryData(); });
                    clearSections('injury');
                });
            });
        }
        if (interventionData) {
            var intKeys = Object.keys(interventionData);
            intKeys.forEach(intKey => {
                var keys = Object.keys(interventionData[intKey]);
                keys.forEach(key => {
                    incidentTrackingAjax.itDeleteConsumerInterventions(key, () => {
                        getInterventionData();
                        clearSections('intervention');
                    });
                });
            });
        }
        if (reviewData) {
            var revKeys = Object.keys(reviewData);
            revKeys.forEach(revKey => {
                var keys = Object.keys(reviewData[revKey]);
                keys.forEach(key => {
                    incidentTrackingAjax.itDeleteConsumerReviews(key, () => {
                        getReviewData();
                        clearSections('review');
                    });
                });
            });
        }
        if (reportingData) {
            var repKeys = Object.keys(reportingData);
            repKeys.forEach(repKey => {
                var keys = Object.keys(reportingData[repKey]);
                keys.forEach(key => {
                    incidentTrackingAjax.itDeleteConsumerReporting(key, () => {
                        getReportData();
                        clearSections('report');
                    });
                });
            });
        }
        if (behaviorData) {
            var bhKeys = Object.keys(behaviorData);
            bhKeys.forEach(fuKey => {
                var keys = Object.keys(behaviorData[fuKey]);
                keys.forEach(key => {
                    incidentTrackingAjax.itDeleteConsumerBehavior(key, () => {
                        getBehaviorData();
                        clearSections('behavior');
                    });
                });
            });
        }
        incidentTrackingAjax.itDeleteConsumerInvolved(SelectedIncidentId, consumerId, itDeleteConsumerInvolvedCallBack);
    }
    function itDeleteConsumerInvolvedCallBack(res) {
        itConsumersInvoled = itConsumersInvoled.filter(c => c.consumerId !== consumerId);
        var consumerBtn = document.getElementById('btnRemoveConsumer');
        if (consumerBtn) {
            if (itConsumersInvoled.length > 1) {
                consumerBtn.classList.remove('disabled');
            } else {
                consumerBtn.classList.add('disabled');
            }
        }
        consumerId = itConsumersInvoled[0].consumerId;
        updateIndividualNavMenuItems();       

    }
    function buildSection() {
        var wrap = document.createElement('div');
        topDiv = document.createElement('div');
        topDiv.style.height = '75px';
        topDiv.style.marginBottom = '15px';
        topDiv.style.display = 'none';
        var consumerPhotoDiv = document.createElement('div');
        consumerPhotoDiv.classList.add('image-text');
        consumerPhoto = document.createElement('img');
        consumerPhotoDiv.appendChild(consumerPhoto);
        var divText = document.createElement('div');
        divText.classList.add('text');
        consumerNameP = document.createElement('p');
        divText.appendChild(consumerNameP);
        consumerPhotoDiv.appendChild(divText);
        topDiv.appendChild(consumerPhotoDiv);
        var btnWrap = document.createElement('div');
        btnWrap.id = 'btnRemoveConsumerWrap';
        btnWrap.classList.add('btnWrap');       
        btnWrap.style.float = 'right';
        var deleteBtn = button.build({
            id: 'btnRemoveConsumer',
            text: 'Remove Individual From Incident',
            style: 'secondary',
            type: 'contained',
            callback: showConsumerDeleteWarning,
        });
        if (itConsumersInvoled && itConsumersInvoled.length == 1) {
            deleteBtn.classList.add('disabled');
        }
        if (!$.session.incidentTrackingDelete) {
            deleteBtn.classList.add('disabled');
        }
        btnWrap.appendChild(deleteBtn);
        topDiv.appendChild(btnWrap);
        wrap.appendChild(topDiv);

        var contentWrapper = document.createElement('div');
        contentWrapper.classList.add('leftMenuWrapper');
        var navElementWrapper = document.createElement('div');
        navElementWrapper.classList.add('leftSidebar');
        var navEle = buildNavigation();
        navElementWrapper.appendChild(navEle);
        contentWrapper.appendChild(navElementWrapper);

        contentDiv = document.createElement('div');
        contentDiv.classList.add('contentArea');       
        var incidentSection = document.createElement('div');
        incidentSection.classList.add('incidentSection');
        incidentSection.appendChild(buildBehaviourContent());
        incidentSection.appendChild(buildFollowupContent());
        incidentSection.appendChild(buildInjuryTable());
        incidentSection.appendChild(buildInterventionTable());
        incidentSection.appendChild(buildReportTable());
        incidentSection.appendChild(buildReviewTable());
        contentDiv.style.flex = '1';
        incidentSection.style.padding = '20px';        
        contentDiv.appendChild(incidentSection);
        contentWrapper.appendChild(contentDiv);
        wrap.appendChild(contentWrapper);
        return wrap;
    }
    function clearSections(sectionName) {
        if (sectionName == 'behavior') {
            var behaviourEntry = document.querySelector('div.behaviourContent');
            if (behaviourEntry) {
                behaviourEntry.innerHTML = '';
                addBehaviourBtn.classList.remove('hidden');
                clearBehaviourForm();
            }
        }

        if (sectionName == 'followup') {
            var section = document.querySelector('div.section');
            if (section) {
                section.innerHTML = '';
                addFollowupBtn.classList.remove('hidden');
                clearFollowupFormDataDefaults();
            }
        }

        if (sectionName == 'injury') {
            var section = document.querySelector('div.injury_section');
            if (section) {
                section.innerHTML = '';
                addInjuryBtn.classList.remove('hidden');
                clearInjuryFormDataDefaults();
            }
        }

        if (sectionName == 'intervention') {
            var section = document.querySelector('div.intervention_section');
            if (section) {
                section.innerHTML = '';
                adInterventionBtn.classList.remove('hidden');
                clearInterventionFormDataDefaults();
            }
        }

        if (sectionName == 'report') {
            var section = document.querySelector('div.report_section');
            if (section) {
                section.innerHTML = '';
                addReportBtn.classList.remove('hidden');
                clearReportFormDataDefaults();
            }
        }

        if (sectionName == 'review') {
            section = document.querySelector('div.review_section');
            if (section) {
                section.innerHTML = '';
                newReviewBtn.classList.remove('hidden');
                clearReviewedFormDataDefaults();
            }
        }
        if (isEdit)
            isEdit = false;

    }
    function populateLocations(res) {
        var data = res.map(r => {
            var value = r.ID;
            var text = r.Name;

            return {
                value,
                text,
            };
        });
        incidentLocations = res;
    }
    function initIncidentDetails() {

        incidentTrackingAjax.getIncidentEditReviewDataAllObjects(SelectedIncidentId, results => {
            results["locations"] = incidentLocations;
            incidentDetails.init(SelectedIncidentId, SelectedConsumer, results, newIncident);
        });
    }
    async function init() {
        try {             
            if ($.session.incidentTrackingUpdate === true) { formReadOnly = false }
            else if (newIncident === true && $.session.incidentTrackingInsert === true) { formReadOnly = false; }
            else { formReadOnly = true; }
            getConsumerBehaviorTypes();
            getFollowuptypes();
            await getinjuryDropdownData();
            getInterventionTypes();
            getReportDropdownData();
            getReviewDropdownData();
            DOM.clearActionCenter();
            var detailCard = buildSection();
            DOM.ACTIONCENTER.appendChild(detailCard);
            detailCard.addEventListener('click', function (event) {
                if (event.target.matches("a.individual_nav")) {
                    event.preventDefault();
                    handleIndividualNavEvents(event.target);

                }
                if (event.target.matches("a.incident_details_link")) {
                    event.preventDefault();
                    initIncidentDetails();
                }
            });
            incidentTrackingAjax.getReviewPageLocations(populateLocations);
            updateIndividualNavMenuItems();
        }
        catch (error) {
            hideProgressPopup();
            console.log(error);
            failSave.show('An error occured');
            setTimeout(() => { failSave.hide(); }, 3000);
        }
    }
    function showProgressPopup(message) {
        pageLoadPopup = POPUP.build({
            hideX: true,
        });
        pageLoadPopup.style.minHeight = '40%';

        // magic to make overlay cover entire site for this once instance
        const overlayDiv = document.querySelector('div.overlay');
        const menuDiv = document.querySelector('div.module-menu');
        overlayDiv.style.zIndex = '100';
        menuDiv.style.zIndex = '99';

        const spinner = PROGRESS.SPINNER.get(message);
        spinner.style.display = 'block';
        pageLoadPopup.appendChild(spinner);
        POPUP.show(pageLoadPopup);
    }
    function hideProgressPopup() {
        const overlayDiv = document.querySelector('div.overlay');
        const menuDiv = document.querySelector('div.module-menu');
        overlayDiv.style.zIndex = '30';
        menuDiv.style.zIndex = '100';
        POPUP.hide(pageLoadPopup);
    }
    return {
        init,
        setGlobalVariables: function (incidentId, selectedConsumerId, consumersInvolved, selectedConsumer, isNewIncident) {
            SelectedIncidentId = incidentId;
            consumerId = selectedConsumerId;
            itConsumersInvoled = consumersInvolved;
            SelectedConsumer = selectedConsumer;
            newIncident = isNewIncident;
        }
    }
})();